import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   useColorModeValue,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   Grid,
   GridItem,
   Button,
   Checkbox,
   RadioGroup,
   Stack,
   Radio,
   ModalFooter,
   useToast,
   Step,
   Stepper,
   Box,
   StepIndicator,
   StepStatus,
   StepIcon,
   StepNumber,
   StepTitle,
   StepDescription,
   StepSeparator,
   Text,
   useColorMode,
} from '@chakra-ui/react';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
   addAccount,
   updateAccount,
   getAccount,
   getAccountForMaster,
   getAccountForCashBank,
} from '../../../../../redux/actions/account';
// import { getCountries } from '../../../../../redux/actions/country';
// import { getCities } from '../../../../../redux/actions/city';
// import { getStates } from '../../../../../redux/actions/state';
import { getGLGroups } from '../../../../../redux/actions/glGroup';
import { getGroupIDs } from '../../../../../redux/actions/companyGroup';
import { getTransport } from '../../../../../redux/actions/transport';
import { getAllBank, getBank } from '../../../../../redux/actions/bank';
import { getSalesRepresentative } from '../../../../../redux/actions/salesRepresentative';
import { renderFormControl, renderSelectFormControl, renderSwitchControl } from 'utils/DynamicFormData';
import * as Yup from 'yup';
import { AsseseeType } from 'utils/dropdownEnum';
import { BUSINESS_TYPE } from 'utils/dropdownEnum';
import { COMPOUND_METHOD } from 'utils/dropdownEnum';
import { BLOOD_GROUP } from 'utils/dropdownEnum';
// import { MARITAL_STATUS } from 'utils/dropdownEnum';
import { CREDIT_LIMIT_TYPE } from 'utils/dropdownEnum';
import { MSME_TYPE } from 'utils/dropdownEnum';
import { PRICE_LEVELS } from 'utils/dropdownEnum';
import { ActionMode } from 'utils/dropdownEnum';
import { LicensesType } from 'utils/dropdownEnum';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useUser } from '../../../../../contexts/UserContext';

import { useGlobal } from '../../../../../contexts';
import { userGlobalSettings } from '../../../../../redux/actions/user';
import { getCompanyDetailsByGst } from '../../../../../redux/actions/company';
import { COMPANY_TYPE } from 'utils/dropdownEnum';

const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   glGroupId: Yup.string().required('gl group is required').notOneOf([''], 'gl group is required'),
   mobile: Yup.string()
      .nullable()
      .test(
         'Mobile number must be 10 digits',
         (value) =>
            !value ||
            (/^\d{10}$/).test(value)
      ),
   udhyogAadharNumber: Yup.string()
      .nullable()
      .test(
         'Invalid Udyam registration number (Format: UDYAM-XX-00-0000000)',
         (value) =>
            !value ||
            (/^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/).test(value)
      ),
   gstRegNo: Yup.string()
      .nullable()
      .test(
         'gst-format',
         'Invalid GST number format',
         (value) =>
            !value ||
            (/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/).test(value)
      ),

   panNo: Yup.string()
      .nullable()
      .test(
         'pan-format',
         'Invalid PAN number format',
         (value) =>
            !value ||
            (/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/).test(value)
      ),

   email: Yup.string()
      .nullable()
      .test(
         'email-format',
         'Invalid email format',
         (value) =>
            !value ||
            (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/).test(value)
      ),

   address1: Yup.string()
      .nullable()
      .test(
         'address-not-numeric-only',
         'Address cannot be numbers only',
         (value) => !value || !/^\d+$/.test(value)
      ),

   address2: Yup.string()
      .nullable()
      .test(
         'address-not-numeric-only',
         'Address cannot be numbers only',
         (value) => !value || !/^\d+$/.test(value)
      ),

   address3: Yup.string()
      .nullable()
      .test(
         'address-not-numeric-only',
         'Address cannot be numbers only',
         (value) => !value || !/^\d+$/.test(value)
      ),

   // pincode: Yup.number()
   //   .min(6, 'Pincode must be at least 6 characters long')
   //   .max(6, 'Pincode must be at least 6 characters long'),
   // phone: Yup.number()
   //   .min(10, 'Phone must be at least 10 characters long')
   //   .max(10, 'Phone must be at least 10 characters long'),
});

const AddEditForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   initialData = null,
   parentGlGroup,
   onSave,
   saveandcontinue = true,
   demoname,
   // handleRefreshData,
   allAccount,
   formType,
   sorting,
   debouncedSearchQuery,
   limit,
   pagination,
   currentPage,
   isAbs = false,
}) => {
   const { cityList, stateList, countryList } = useGlobal();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   // const countryList = useSelector((state) => state.country.list);
   // const stateList = useSelector((state) => state.state.list);
   // const cityList = useSelector((state) => state.city.list);
   const accountList = useSelector((state) => state.account.list);
   const getGLGroupsList = useSelector((state) => state.glGroup.list);
   const transportData = useSelector((state) => state.transport?.list);
   const bankBranchData = useSelector((state) => state.bank?.list);
   const bankData = useSelector((state) => state.bank?.listAllBank);
   const salesRepresentativeData = useSelector((state) => state.salesRepresentative?.list);
   const dbName = localStorage.getItem('dbName');
   const { companyList, userGlobalSettingsData } = useGlobal();
   const company = useSelector((state) => state.company.gstDetail);
   const [isLoading, setIsLoading] = useState(false);
   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);
   const shouldSendCompanyidAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyidBankBranch = userGlobalSettingsData?.[0]?.askCompany?.bankBranch || false;
   const shouldSendCompanyidTransport = userGlobalSettingsData?.[0]?.askCompany?.transport || false;
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );
   // const cities = useSelector((state) => state.city.list);

   const [activeStep, setActiveStep] = useState(0);
   const [isSameAddress, setIsSameAddress] = useState(true);
   const { user } = useUser();

   const toast = useToast();
   const dispatch = useDispatch();
   const { control } = useForm();

   const steps = [
      { title: 'Basic' },
      { title: 'Tax & TDS details', description: 'Configure Tax & TDS details' },
      { title: 'Credit Limits' },
      { title: 'Others 1' },
   ];
   // const watchedFields = watch();

   const textColor = useColorModeValue('#9E9E9E', 'white');

   const [errors, setErrors] = useState({});

   const handleOnClose = () => {
      setActiveStep(0);
      onClose();
   };

   const handleNext = async () => {
      const isValid = await validateStep();
      if (isValid) {
         if (activeStep < steps.length - 1) {
            setActiveStep(activeStep + 1);
         } else {
            onFormSubmit();
         }
      } else {
         // toast({
         //    title: 'Validation Error',
         //    description: 'Please correct the errors.',
         //    status: 'error',
         //    duration: 3000,
         //    isClosable: true,
         // });
      }
   };

   const handlePrevious = () => {
      if (activeStep > 0) {
         setActiveStep(activeStep - 1);
      }
   };

   const [row, setRow] = useState({
      compIds: [],
      //1 Basic
      gst: '',
      name: '',
      mobile: null,
      panNo: '',
      address1: '',
      address2: '',
      address3: '',
      pincode: null,
      balance: '',
      balanceType: '',
      stateId: null,
      coId: null,
      cityId: '',
      areaId: null,
      glGroupId: null,
      companyType: null,
      // addressJson: [],
      //1 Basic

      //2 Shipping Details
      shippingAddress1: '',
      shippingAddress2: '',
      shippingAddress3: '',
      shippingCityId: '',
      shippingStateId: '',
      shippingCoId: '',
      shippingPincode: '',
      //2 Shipping Details

      //3 Tax & TDS details
      lSalesTaxNo: '', //Text
      lSalesTaxDate: '', //Text date
      vatRegNo: '', //Text
      vatRegDate: '', //Text date
      cstTinNo: '', //Text
      cstTinDate: '', //Text date
      cSalesTaxNumber: '', //Text
      cSalesTaxDate: '', //Text date
      serviceTaxNo: '', //Text
      serviceTaxDate: '', //Text date
      licensesType: '', // Drop Enum
      itWardNumber: '', // Text
      // gst
      eCommMerchantId: '', //Text
      asseseeType: '', //Drop Enum
      gstRegNo: '', //Text
      gstRegDate: '', //Text Date
      udhyogAadharNumber: '', //Text
      locatedInSez: '', //Check
      distanceKM: '', //Text Num
      msmeType: '', //Drop Enum
      businessType: '', //Drop Enum
      // tds
      tdsApplicable: '', //check
      tdsAccountId: '', //Dropdown - accounts
      tdsLimit: '', //Text num
      tdsRate: '', //Text num
      tdsNatureOfPayment: '', //Text
      interestRate: null, //Text num
      compoundMethod: '', //Drop Enum
      compoundDays: '', //Text num

      //5 Credit Limits
      email: '', //Text email
      bloodGroup: '', // Drop Enum
      birthDate: '', //Text date
      maritalStatus: false, // Drop Enum
      anniversaryDate: '', //Text date
      languageName: '', //Text
      //
      creditLimitType: '', // Drop Enum
      creditLimit: '', //Text num
      creditLimitActionMode: '', // Drop Enum
      creditLimitDays: '', //Text num

      //6 Others
      code: '', //Text
      groupId: '', // Drop Account Group
      referredById: '', //Drop Account
      salutation: '', //Text - mr. mrs. m/s
      shortName: '', //Text
      aliasName: '', //Text
      printName: '', //Text
      ownerName: '', //Text
      offPhone: '', //Text -- special char allowed
      resPhone: '', //Text -- special char allowed
      factPhone: '', //Text  -- special char allowed
      fax: '', // Text
      contactPerson: '', //Text
      webUrl: '', //Text
      priceLevel: '', //Drop Enum [Leval 1,...,Level 20]
      allowChangePriceLevel: '', //Check
      printOrder: '', //Text num
      depreciation: '', //Text
      originalValue: '', // Text num
      purchaseDate: '', //Text date
      pnLSharePercent: '', // Text num max 100
      ledgerFolioNo: '', // Text
      autoCallOutAdj: '', //Check
      promptBeforeCallOsadj: '', //check
      principalAmt: '', //Text Num
      defaultDueDays: '', // Text Num
      extraDueDays: '', // Text Num
      numOfCopies: '', // Text Num - 1
      color: '', // Text - color picker
      parcelRate: '', // Text Num
      discForSale: '', // Text num
      discForPurchase: '', // Text num
      loginId: '', //autosave
      //7 others 2
      brokerId: '', //Drop account
      transportId: '', //Drop transport
      bankId: '', //Drop bank
      bankBranchId: '', //Drop bank branch
      salesRepresentativeId: '', //Drop sales reprentative
      broker2Id: '', //Drop  Acc
      deliveryId: '', //Drop  Acc
      hasteId: '', //Drop  acc
      masterId: '', //Drop
      notes: '', //Text
      notes1: '', //Text
      notes2: '', //Text
      status: true, //Check
      isBlacklisted: false, //Check
      reason: '', //Text
      syncCode: '', //Number
      sendWhatsApp: true,
   });

   const clearFormData = () => {
      setRow({
         gst: '',
         name: '',
         mobile: null,
         panNo: '',
         address: '',
         address2: '',
         // shippingAddress: '',
         pincode: null,
         balance: '',
         balanceType: '',
         stateId: null,
         coId: null,
         cityId: null,
         areaId: null,
         glGroupId: null,
         companyType: null,
         addressJson: [],
         shippingAddress: '',
         shippingCityId: '',
         shippingStateId: '',
         shippingCoId: '',
         shippingPincode: '',
         groupId: '',
         code: '',
         referredById: '',
         salutation: '',
         email: '',
         shortName: '',
         aliasName: '',
         printName: '',
         ownerName: '',
         offPhone: '',
         resPhone: '',
         factPhone: '',
         fax: '',
         contactPerson: '',
         webUrl: '',
         brokerId: '',
         transportId: '',
         isBlacklisted: false,
         reason: '',
         syncCode: '',
         sendWhatsApp: true,
         lSalesTaxNo: '',
         lSalesTaxDate: '',
         vatRegNo: '',
         vatRegDate: '',
         cstTinNo: '',
         cstTinDate: '',
         cSalesTaxNumber: '',
         cSalesTaxDate: '',
         serviceTaxNo: '',
         serviceTaxDate: '',
         licensesType: '',
         itWardNumber: '',
         tdsApplicable: '',
         tdsAccountId: '',
         tdsLimit: '',
         tdsRate: '',
         tdsNatureOfPayment: '',
         interestRate: null,
         compoundMethod: '',
         compoundDays: '',
         creditLimitType: '',
         creditLimit: '',
         creditLimitActionMode: '',
         creditLimitDays: '',
         priceLevel: '',
         allowChangePriceLevel: '',
         bloodGroup: '',
         birthDate: '',
         maritalStatus: false,
         anniversaryDate: '',
         bankId: '',
         bankBranchId: '',
         printOrder: '',
         depreciation: '',
         originalValue: '',
         purchaseDate: '',
         pnLSharePercent: '',
         ledgerFolioNo: '',
         autoCallOutAdj: '',
         promptBeforeCallOsadj: '',
         principalAmt: '',
         defaultDueDays: '',
         extraDueDays: '',
         numOfCopies: '',
         discForSale: '',
         discForPurchase: '',
         deliveryId: '',
         hasteId: '',
         masterId: '',
         status: true,
         notes: '',
         notes1: '',
         notes2: '',
         loginId: '',
         languageName: '',
         eCommMerchantId: '',
         asseseeType: '',
         gstRegNo: '',
         gstRegDate: '',
         udhyogAadharNumber: '',
         locatedInSez: '',
         distanceKM: '',
         msmeType: '',
         businessType: '',
         salesRepresentativeId: '',
         broker2Id: '',
         color: '',
         parcelRate: '',
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         // Only set if not in edit mode and compIds is empty or doesn't include the user's company
         setRow((prev) => {
            if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (isOpen) {
         dispatch(userGlobalSettings());
      }
   }, [dispatch, isOpen]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
         setRow((prev) => ({
            ...prev,
            status: true, // Set status to 1 when adding a new customer
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         })); // Clear data when adding a new item
      } else if (isEditMode && initialData) {
         // Determine the state and country based on city or state IDs
         const billingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'billing') || {};
         const shippingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'shipping') || {};
         // const selectedCity = cityList.find(
         //   (city) => city.id === initialData?.accountaddress?.cityId
         // );
         // const stateId = selectedCity?.stId || initialData?.accountaddress?.stateId;
         // const selectedState = stateList.find((state) => state.id === stateId);
         // const coId = selectedState?.coId || initialData?.accountaddress?.coId;
         const matchedBal = initialData?.balJson?.find(
            (item) => String(item.compId) === String(user?.loginhistory?.companyId),
         );
         setRow({
            gst: initialData?.gstRegNo || '',
            name: initialData?.name || '',
            mobile: initialData?.mobile || '',
            panNo: initialData?.panNo || '',
            // address: initialData?.accountaddress?.address || '',
            // pincode: initialData?.pincode || '',
            balance: matchedBal?.bal ? Math.abs(matchedBal?.bal) : '',
            balanceType: matchedBal ? (matchedBal?.bal >= 0 ? 'payable' : 'receivable') : '',
            status: initialData?.status || true,
            compIds: initialData?.companyIds || [],
            // Set country ID
            // areaId: initialData?.areaId || '',
            city: billingAddress?.city || '',
            address1: billingAddress?.address1 || '',
            address2: billingAddress?.address2 || '',
            pincode: billingAddress?.pincode || '',
            stateId: billingAddress?.stateId || null,
            coId: billingAddress?.coId || null,
            areaId: billingAddress?.areaId || null,
            cityId: billingAddress?.cityId || null,
            shippingAddress1: shippingAddress?.address1 || '',
            shippingCityId: shippingAddress?.cityId || '',
            shippingStateId: shippingAddress?.stateId || '',
            shippingCoId: shippingAddress?.coId || '',
            shippingPincode: shippingAddress?.pincode || '',
            glGroupId: initialData?.glGroupId || null,
            companyType: initialData.companyType || null,
            groupId: initialData?.GroupId || '',
            code: initialData?.code || '',
            referredById: initialData?.referredById || '',
            salutation: initialData?.salutation || '',
            email: initialData?.email || '',
            shortName: initialData?.shortName || '',
            aliasName: initialData?.aliasName || '',
            printName: initialData?.printName || '',
            ownerName: initialData?.ownerName || '',
            offPhone: initialData?.offPhone || '',
            resPhone: initialData?.resPhone || '',
            factPhone: initialData?.factPhone || '',
            fax: initialData?.fax || '',
            contactPerson: initialData?.contactPerson || '',
            webUrl: initialData?.webUrl || '',
            brokerId: initialData?.brokerId || '',
            transportId: initialData?.transportId || '',
            isBlacklisted: initialData?.isBlacklisted || false,
            reason: initialData?.reason || '',
            syncCode: initialData?.syncCode || '',
            sendWhatsApp: initialData?.sendWhatsApp || true,
            lSalesTaxNo: initialData?.lSalesTaxNo || '',
            lSalesTaxDate: initialData?.lSalesTaxDate
               ? new Date(initialData?.lSalesTaxDate).toISOString().split('T')[0]
               : '',
            vatRegNo: initialData?.vatRegNo || '',
            vatRegDate: initialData?.vatRegDate ? new Date(initialData?.vatRegDate).toISOString().split('T')[0] : '',
            cstTinNo: initialData?.cstTinNo || '',
            cstTinDate: initialData?.cstTinDate ? new Date(initialData?.cstTinDate).toISOString().split('T')[0] : '',
            cSalesTaxNumber: initialData?.cSalesTaxNumber || '',
            cSalesTaxDate: initialData?.cSalesTaxDate
               ? new Date(initialData?.cSalesTaxDate).toISOString().split('T')[0]
               : '',
            serviceTaxNo: initialData?.serviceTaxNo || '',
            serviceTaxDate: initialData?.serviceTaxDate
               ? new Date(initialData?.serviceTaxDate).toISOString().split('T')[0]
               : '',
            licensesType: initialData?.licensesType || '',
            itWardNumber: initialData?.itWardNumber || '',
            tdsApplicable: initialData?.tdsApplicable || '',
            tdsAccountId: initialData?.tdsAccountId || '',
            tdsLimit: initialData?.tdsLimit || '',
            tdsRate: initialData?.tdsRate || '',
            tdsNatureOfPayment: initialData?.tdsNatureOfPayment || '',
            interestRate: initialData?.interestRate || '',
            compoundMethod: initialData?.compoundMethod || '',
            compoundDays: initialData?.compoundDays || '',
            creditLimitType: initialData?.creditLimitType,
            creditLimit: initialData?.creditLimit || '',
            creditLimitActionMode: initialData?.creditLimitActionMode,
            creditLimitDays: initialData?.creditLimitDays || '',
            priceLevel: initialData?.priceLevel || '',
            allowChangePriceLevel: initialData?.allowChangePriceLevel || '',
            bloodGroup: initialData?.bloodGroup || '',
            birthDate: initialData?.birthDate ? new Date(initialData?.birthDate).toISOString().split('T')[0] : '',
            maritalStatus: initialData?.maritalStatus,
            anniversaryDate: initialData?.anniversaryDate
               ? new Date(initialData?.anniversaryDate).toISOString().split('T')[0]
               : '',
            bankId: initialData?.bankId || '',
            bankBranchId: initialData?.bankBranchId || '',
            printOrder: initialData?.printOrder || '',
            depreciation: initialData?.depreciation,
            originalValue: initialData?.originalValue || '',
            purchaseDate: initialData?.purchaseDate || '',
            pnLSharePercent: initialData?.pnLSharePercent || '',
            ledgerFolioNo: initialData?.ledgerFolioNo || '',
            autoCallOutAdj: initialData?.autoCallOutAdj || '',
            promptBeforeCallOsadj: initialData?.promptBeforeCallOsadj || '',
            principalAmt: initialData?.principalAmt || '',
            defaultDueDays: initialData?.defaultDueDays || '',
            extraDueDays: initialData?.extraDueDays || '',
            numOfCopies: initialData?.numOfCopies || '',
            discForSale: initialData?.discForSale || '',
            discForPurchase: initialData?.discForPurchase || '',
            deliveryId: initialData?.deliveryId || '',
            hasteId: initialData?.hasteId || '',
            masterId: initialData?.masterId || '',
            notes: initialData?.notes || '',
            notes1: initialData?.notes1 || '',
            notes2: initialData?.notes2 || '',
            loginId: initialData?.loginId || '',
            languageName: initialData?.languageName || '',
            eCommMerchantId: initialData?.eCommMerchantId || '',
            asseseeType: initialData?.asseseeType || '',
            gstRegNo: initialData?.gstRegNo || '',
            gstRegDate: initialData?.gstRegDate ? new Date(initialData?.gstRegDate).toISOString().split('T')[0] : '',
            udhyogAadharNumber: initialData?.udhyogAadharNumber || '',
            locatedInSez: initialData?.locatedInSez || '',
            distanceKM: initialData?.distanceKM || '',
            msmeType: initialData?.msmeType || '',
            businessType: initialData?.businessType || '',
            salesRepresentativeId: initialData?.salesRepresentativeId || '',
            broker2Id: initialData?.broker2Id || '',
            color: initialData?.color || '',
            parcelRate: initialData?.parcelRate || '',
         });

         if (shippingAddress && shippingAddress?.id) setIsSameAddress(false);
         else setIsSameAddress(true);
      }
   }, [isEditMode, initialData, cityList, stateList, parentGlGroup]);

   const validateStep = async () => {
      try {
         // Validate the whole row object instead of individual fields
         await validationSchema.validate(row, { abortEarly: false });

         setErrors({}); // Clear previous errors
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   // const getCompanyDetailsByGST = useCallback(
   //   async (gst) => {
   //     dispatch(getCompanyDetailsByGst(gst));
   //   },
   //   [dispatch],
   // );

   const handleInputChange = (field, value) => {
      setRow((prev) => {
         const updatedRow = { ...prev, [field]: value };

         if (field === 'gstRegNo' && value.length === 15) {
            dispatch(getCompanyDetailsByGst(value));
            const panFromGst = value.substring(2, 12); // positions 3 to 8 (index 2 to 8)
            updatedRow.panNo = panFromGst;
         }

         // Autofill state and country when cityId is selected
         if (field === 'cityId') {
            const selectedCity = cityList.find((city) => city.id === Number(value));

            if (selectedCity) {
               updatedRow.stateId = selectedCity.stId; // Auto-fill state
               const selectedState = stateList.find((state) => state.id === selectedCity.stId);
               if (selectedState) {
                  updatedRow.coId = selectedState.coId; // Auto-fill country
               }
            }
         }

         if (field === 'stateId') {
            const selectedState = stateList.find((state) => state.id === Number(value));
            if (selectedState) {
               updatedRow.coId = selectedState.coId; // Auto-fill country based on state
            }
         }

         if (field === 'shippingCityId') {
            const selectedCity = cityList.find((city) => city.id === Number(value));
            if (selectedCity) {
               updatedRow.shippingStateId = selectedCity.stId; // Auto-fill shipping state
               const selectedState = stateList.find((state) => state.id === selectedCity.stId);
               if (selectedState) {
                  updatedRow.shippingCoId = selectedState.coId; // Auto-fill shipping country
               }
            }
         }

         if (field === 'shippingStateId') {
            const selectedState = stateList.find((state) => state.id === Number(value));
            if (selectedState) {
               updatedRow.shippingCoId = selectedState.coId; // Auto-fill shipping country based on state
            }
         }

         // if (field === 'gst')
         // if (value.length === 15) getCompanyDetailsByGST(value);

         return updatedRow;
      });

      // Clear the specific field error when user starts typing
      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const handleSwitchChange = (field) => (event) => {
      setRow((prev) => ({
         ...prev,
         [field]: event.target.checked, // Updates boolean value (true/false)
      }));
   };

   const handleSameAddressChange = (e) => {
      const isChecked = e.target.checked;
      setIsSameAddress(isChecked);

      if (isChecked) {
         // When checkbox is checked, copy main address to shipping address
         setRow((prev) => ({
            ...prev,
            shippingAddress: prev.address1,
            shippingCityId: prev.cityId,
            shippingStateId: prev.stateId,
            shippingCoId: prev.coId,
            shippingPincode: prev.pincode,
         }));
      } else {
         // When checkbox is unchecked, clear the shipping address fields for editing
         setRow((prev) => ({
            ...prev,
            shippingAddress: '',
            shippingCityId: '',
            shippingStateId: '',
            shippingCoId: '',
            shippingPincode: '',
         }));
      }
   };

   const onFormSubmit = async () => {
      const isValid = await validateStep();
      if (!isValid) {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               glGroupRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         }
         // toast({
         //    title: 'Validation Error',
         //    description: 'Please correct the errors.',
         //    status: 'error',
         //    duration: 3000,
         //    isClosable: true,
         // });
         return;
      }
      setIsLoading(true);
      const billingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'billing') || {};
      const shippingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'shipping') || {};
      const newBalObject = {
         compId: String(user?.loginhistory?.companyId),
         bal:
            row.balanceType === 'payable'
               ? Number(row.balance)
               : row.balanceType === 'receivable'
                  ? -Number(row.balance)
                  : Number(row.balance),
      };

      let balJson = initialData?.balJson
         ? initialData.balJson.filter(
            (item) =>
               item.compId !== 'undefined' &&
               item.compId !== undefined &&
               item.compId !== 'null' &&
               item.compId !== null &&
               item.compId !== '' &&
               String(item.compId) !== String(user?.loginhistory?.companyId),
         )
         : [];
      balJson.push(newBalObject);
      let addressJson = {
         ...(isEditMode && initialData ? { id: billingAddress.id } : {}),
         // name: row.name,
         name: 'billing',
         address1: row.address1,
         gst: row.gst,
         mobile: row.mobile,
         email: row?.email || '',
         pincode: row.pincode,
         areaId: row.areaId || null,
         coId: row.coId,
         stateId: row.stateId,
         cityId: row.cityId,
      };
      let shippingAddressJson = {
         ...(isEditMode && initialData ? { id: shippingAddress.id } : {}),
         name: 'shipping',
         address1: row.shippingAddress1 || row.address1, // Use shippingAddress if provided
         address2: row.address2,
         pincode: row.shippingPincode || '', // Use shippingPincode for the shipping address
         areaId: row.areaId || null,
         coId: row.shippingCoId || row.coId, // Use shippingCoId if available
         stateId: row.shippingStateId || row.stateId, // Use shippingStateId if available
         cityId: row.shippingCityId || row.cityId, // Use shippingCityId if available
      };
      const processedData = {
         glGroupId: row.glGroupId,
         companyType: row.companyType,
         compIds: row.compIds,
         name: row.name,
         gst: row.gst,
         mobile: row.mobile,
         // balance: row.balance,
         status: row.status,
         // balanceType: row.balanceType,
         email: row.email,
         panNo: row.panNo,
         pincode: row.pincode,
         areaId: row.areaId || null,
         balJson: balJson ? balJson : [balJson],
         addressJson: [addressJson],
         groupId: row.groupId || null,
         code: row.code || '',
         referredById: row.referredById || null,
         salutation: row.salutation || '',
         shortName: row.shortName || '',
         aliasName: row.aliasName || '',
         printName: row.printName || '',
         ownerName: row.ownerName || '',
         offPhone: row.offPhone || '',
         resPhone: row.resPhone || '',
         factPhone: row.factPhone || '',
         fax: row.fax || '',
         contactPerson: row.contactPerson || '',
         webUrl: row.webUrl || '',
         brokerId: row.brokerId || null,
         transportId: row.transportId || null,
         isBlacklisted: row.isBlacklisted || false,
         reason: row.reason || '',
         syncCode: row.syncCode || '',
         sendWhatsApp: row.sendWhatsApp || true,
         lSalesTaxNo: row.lSalesTaxNo || '',
         lSalesTaxDate: row.lSalesTaxDate || null,
         vatRegNo: row.vatRegNo || '',
         vatRegDate: row.vatRegDate || null,
         cstTinNo: row.cstTinNo || '',
         cstTinDate: row.cstTinDate || null,
         cSalesTaxNumber: row.cSalesTaxNumber || '',
         cSalesTaxDate: row.cSalesTaxDate || null,
         serviceTaxNo: row.serviceTaxNo || '',
         serviceTaxDate: row.serviceTaxDate || null,
         licensesType: row.licensesType || null,
         itWardNumber: row.itWardNumber || '',
         tdsApplicable: row.tdsApplicable || null,
         tdsAccountId: row.tdsAccountId || null,
         tdsLimit: row.tdsLimit || null,
         tdsRate: row.tdsRate || null,
         tdsNatureOfPayment: row.tdsNatureOfPayment || '',
         interestRate: row.interestRate ? row.interestRate : null,
         compoundMethod: row.compoundMethod ? row.compoundMethod : null,
         compoundDays: row.compoundDays ? row.compoundDays : null,
         creditLimitType: row.creditLimitType ? row.creditLimitType : null,
         creditLimit: row.creditLimit ? row.creditLimit : null,
         creditLimitActionMode: row.creditLimitActionMode ? row.creditLimitActionMode : null,
         creditLimitDays: row.creditLimitDays ? row.creditLimitDays : null,
         priceLevel: row.priceLevel ? row.priceLevel : null,
         allowChangePriceLevel: row.allowChangePriceLevel ? row.allowChangePriceLevel : null,
         bloodGroup: row.bloodGroup || '',
         birthDate: row.birthDate || null,
         maritalStatus: row.maritalStatus,
         anniversaryDate: row.anniversaryDate || null,
         bankId: row.bankId || null,
         bankBranchId: row.bankBranchId || null,
         printOrder: row.printOrder ? row.printOrder : null,
         depreciation: row.depreciation ? row.depreciation : null,
         originalValue: row.originalValue ? row.originalValue : null,
         purchaseDate: row.purchaseDate || null,
         pnLSharePercent: row.pnLSharePercent ? row.pnLSharePercent : null,
         ledgerFolioNo: row.ledgerFolioNo || '',
         autoCallOutAdj: row.autoCallOutAdj
            ? row.autoCallOutAdj
            : row.autoCallOutAdj === false
               ? row.autoCallOutAdj
               : null,
         promptBeforeCallOsadj: row.promptBeforeCallOsadj
            ? row.promptBeforeCallOsadj
            : row.promptBeforeCallOsadj === false
               ? row.promptBeforeCallOsadj
               : null,
         principalAmt: row.principalAmt ? row.principalAmt : null,
         defaultDueDays: row.defaultDueDays ? Number(row.defaultDueDays) : null,
         extraDueDays: row.extraDueDays ? row.extraDueDays : null,
         numOfCopies: row.numOfCopies ? row.numOfCopies : null,
         discForSale: row.discForSale ? row.discForSale : null,
         discForPurchase: row.discForPurchase ? row.discForPurchase : null,
         deliveryId: row.deliveryId || null,
         hasteId: row.hasteId || null,
         masterId: row.masterId || null,
         notes: row.notes || '',
         notes1: row.notes1 || '',
         notes2: row.notes2 || '',
         loginId: row.loginId || null,
         languageName: row.languageName || '',
         eCommMerchantId: row.eCommMerchantId || '',
         asseseeType: row.asseseeType ? row.asseseeType : null,
         gstRegNo: row.gstRegNo || '',
         gstRegDate: row.gstRegDate || null,
         udhyogAadharNumber: row.udhyogAadharNumber || '',
         locatedInSez: row.locatedInSez ? row.locatedInSez : row.locatedInSez === false ? row.locatedInSez : null,
         distanceKM: row.distanceKM ? row.distanceKM : null,
         msmeType: row.msmeType ? row.msmeType : null,
         businessType: row.businessType ? row.businessType : null,
         salesRepresentativeId: row.salesRepresentativeId || null,
         broker2Id: row.broker2Id || null,
         color: row.color || '',
         parcelRate: row.parcelRate ? row.parcelRate : null,
      };

      if (!isSameAddress) {
         processedData.addressJson.push(shippingAddressJson);
      }

      // delete processedData.balance;
      // delete processedData.balanceType;
      delete processedData.pincode;
      delete processedData.gst;
      try {
         if (isEditMode && initialData && initialData.id) {
            processedData.id = initialData.id;

            await dispatch(updateAccount(processedData));
         } else {
            const response = await dispatch(addAccount(processedData));

            if (response?.code === 1) {
               onSave(response.data);
            }
         }
         setIsLoading(false);
         // handleRefreshData();
         clearFormData();
         setActiveStep(0);
         onClose();
         await dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
               page: currentPage,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            }),
         );
         await dispatch(
            getAccountForMaster({
               compId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
               page: currentPage,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            }),
         );
         await dispatch(
            getAccountForCashBank({
               compId: user?.loginhistory?.companyId,
               status: true,
               ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         // Close the modal
         // onClose();
      } catch (error) {
         // toast({
         //    title: 'Error',
         //    description: error.message || 'An error occurred while saving the category.',
         //    status: 'error',
         //    duration: 3000,
         //    isClosable: true,
         // });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      const isValid = await validateStep();
      if (!isValid) {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               glGroupRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         }
         // toast({
         //    title: 'Validation Error',
         //    description: 'Please correct the errors.',
         //    status: 'error',
         //    duration: 3000,
         //    isClosable: true,
         // });
         return;
      }
      setIsLoading(true);
      const billingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'billing') || {};
      const shippingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'shipping') || {};
      const newBalObject = {
         compId: String(user?.loginhistory?.companyId),
         bal:
            row.balanceType === 'payable'
               ? Number(row.balance)
               : row.balanceType === 'receivable'
                  ? -Number(row.balance)
                  : Number(row.balance),
      };

      let balJson = initialData?.balJson
         ? initialData.balJson.filter(
            (item) =>
               item.compId !== 'undefined' &&
               item.compId !== undefined &&
               item.compId !== 'null' &&
               item.compId !== null &&
               item.compId !== '' &&
               String(item.compId) !== String(user?.loginhistory?.companyId),
         )
         : [];
      balJson.push(newBalObject);
      let addressJson = {
         ...(isEditMode && initialData ? { id: billingAddress.id } : {}),
         // name: row.name,
         name: 'billing',
         address1: row.address1,
         gst: row.gst,
         mobile: row.mobile,
         email: row?.email || '',
         pincode: row.pincode,
         areaId: row.areaId || null,
         coId: row.coId,
         stateId: row.stateId,
         cityId: row.cityId,
      };
      let shippingAddressJson = {
         ...(isEditMode && initialData ? { id: shippingAddress.id } : {}),
         name: 'shipping',
         address1: row.shippingAddress1 || row.address1, // Use shippingAddress if provided
         address2: row.address2,
         pincode: row.shippingPincode || '', // Use shippingPincode for the shipping address
         areaId: row.areaId || null,
         coId: row.shippingCoId || row.coId, // Use shippingCoId if available
         stateId: row.shippingStateId || row.stateId, // Use shippingStateId if available
         cityId: row.shippingCityId || row.cityId, // Use shippingCityId if available
      };
      const processedData = {
         glGroupId: row.glGroupId,
         companyType: row.companyType,
         name: row.name,
         gst: row.gst,
         mobile: row.mobile,
         // balance: row.balance,
         status: row.status,
         // balanceType: row.balanceType,
         email: row.email,
         panNo: row.panNo,
         pincode: row.pincode,
         areaId: row.areaId || null,
         balJson: balJson ? balJson : [balJson],
         addressJson: [addressJson],
         groupId: row.groupId || null,
         code: row.code || '',
         referredById: row.referredById || null,
         salutation: row.salutation || '',
         shortName: row.shortName || '',
         aliasName: row.aliasName || '',
         printName: row.printName || '',
         ownerName: row.ownerName || '',
         offPhone: row.offPhone || '',
         resPhone: row.resPhone || '',
         factPhone: row.factPhone || '',
         fax: row.fax || '',
         contactPerson: row.contactPerson || '',
         webUrl: row.webUrl || '',
         brokerId: row.brokerId || null,
         transportId: row.transportId || null,
         isBlacklisted: row.isBlacklisted || false,
         reason: row.reason || '',
         syncCode: row.syncCode || '',
         sendWhatsApp: row.sendWhatsApp || true,
         lSalesTaxNo: row.lSalesTaxNo || '',
         lSalesTaxDate: row.lSalesTaxDate || null,
         vatRegNo: row.vatRegNo || '',
         vatRegDate: row.vatRegDate || null,
         cstTinNo: row.cstTinNo || '',
         cstTinDate: row.cstTinDate || null,
         cSalesTaxNumber: row.cSalesTaxNumber || '',
         cSalesTaxDate: row.cSalesTaxDate || null,
         serviceTaxNo: row.serviceTaxNo || '',
         serviceTaxDate: row.serviceTaxDate || null,
         licensesType: row.licensesType || null,
         itWardNumber: row.itWardNumber || '',
         tdsApplicable: row.tdsApplicable || null,
         tdsAccountId: row.tdsAccountId || null,
         tdsLimit: row.tdsLimit || null,
         tdsRate: row.tdsRate || null,
         tdsNatureOfPayment: row.tdsNatureOfPayment || '',
         interestRate: row.interestRate ? row.interestRate : null,
         compoundMethod: row.compoundMethod ? row.compoundMethod : null,
         compoundDays: row.compoundDays ? row.compoundDays : null,
         creditLimitType: row.creditLimitType ? row.creditLimitType : null,
         creditLimit: row.creditLimit ? row.creditLimit : null,
         creditLimitActionMode: row.creditLimitActionMode ? row.creditLimitActionMode : null,
         creditLimitDays: row.creditLimitDays ? row.creditLimitDays : null,
         priceLevel: row.priceLevel ? row.priceLevel : null,
         allowChangePriceLevel: row.allowChangePriceLevel ? row.allowChangePriceLevel : null,
         bloodGroup: row.bloodGroup || '',
         birthDate: row.birthDate || null,
         maritalStatus: row.maritalStatus,
         anniversaryDate: row.anniversaryDate || null,
         bankId: row.bankId || null,
         bankBranchId: row.bankBranchId || null,
         printOrder: row.printOrder ? row.printOrder : null,
         depreciation: row.depreciation ? row.depreciation : null,
         originalValue: row.originalValue ? row.originalValue : null,
         purchaseDate: row.purchaseDate || null,
         pnLSharePercent: row.pnLSharePercent ? row.pnLSharePercent : null,
         ledgerFolioNo: row.ledgerFolioNo || '',
         autoCallOutAdj: row.autoCallOutAdj
            ? row.autoCallOutAdj
            : row.autoCallOutAdj === false
               ? row.autoCallOutAdj
               : null,
         promptBeforeCallOsadj: row.promptBeforeCallOsadj
            ? row.promptBeforeCallOsadj
            : row.promptBeforeCallOsadj === false
               ? row.promptBeforeCallOsadj
               : null,
         principalAmt: row.principalAmt ? row.principalAmt : null,
         defaultDueDays: row.defaultDueDays ? Number(row.defaultDueDays) : null,
         extraDueDays: row.extraDueDays ? row.extraDueDays : null,
         numOfCopies: row.numOfCopies ? row.numOfCopies : null,
         discForSale: row.discForSale ? row.discForSale : null,
         discForPurchase: row.discForPurchase ? row.discForPurchase : null,
         deliveryId: row.deliveryId || null,
         hasteId: row.hasteId || null,
         masterId: row.masterId || null,
         notes: row.notes || '',
         notes1: row.notes1 || '',
         notes2: row.notes2 || '',
         loginId: row.loginId || null,
         languageName: row.languageName || '',
         eCommMerchantId: row.eCommMerchantId || '',
         asseseeType: row.asseseeType ? row.asseseeType : null,
         gstRegNo: row.gstRegNo || '',
         gstRegDate: row.gstRegDate || null,
         udhyogAadharNumber: row.udhyogAadharNumber || '',
         locatedInSez: row.locatedInSez ? row.locatedInSez : row.locatedInSez === false ? row.locatedInSez : null,
         distanceKM: row.distanceKM ? row.distanceKM : null,
         msmeType: row.msmeType ? row.msmeType : null,
         businessType: row.businessType ? row.businessType : null,
         salesRepresentativeId: row.salesRepresentativeId || null,
         broker2Id: row.broker2Id || null,
         color: row.color || '',
         parcelRate: row.parcelRate ? row.parcelRate : null,
      };

      if (!isSameAddress) {
         processedData.addressJson.push(shippingAddressJson);
      }

      // delete processedData.balance;
      // delete processedData.balanceType;
      delete processedData.pincode;
      delete processedData.gst;
      try {
         if (isEditMode && initialData && initialData.id) {
            processedData.id = initialData.id;

            dispatch(updateAccount(processedData));
         } else {
            const response = await dispatch(addAccount(processedData));

            if (response?.code === 1) {
               onSave(response.data);
            }
         }
         // handleRefreshData();
         setIsLoading(false);
         clearFormData();
         setActiveStep(0);
         await dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
               // search: ,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            }),
         );
         // Close the modal
         onClose();
      } catch (error) {
         // toast({
         //    title: 'Error',
         //    description: error.message || 'An error occurred while saving the category.',
         //    status: 'error',
         //    duration: 3000,
         //    isClosable: true,
         // });
         setIsLoading(false);
      }
   };

   // const handleSubmit = async () => {
   //   const isValid = await validateStep();
   //   if (isValid) {
   //     onFormSubmit(); // Call the form submit logic if validation is successful
   //   } else {
   //     toast({
   //       title: 'Validation Error',
   //       description: 'Please correct the errors before saving.',
   //       status: 'error',
   //       duration: 3000,
   //       isClosable: true,
   //     });
   //   }
   // };

   useEffect(() => {
      if (isOpen) {
         // dispatch(getCountries());
         // dispatch(getStates());
         // dispatch(getCities());
         dispatch(getGLGroups());
         dispatch(getGroupIDs());
         dispatch(getTransport({ ...(shouldSendCompanyidTransport && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(getBank({ ...(shouldSendCompanyidBankBranch && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(getSalesRepresentative());
         dispatch(getAllBank());
      }
   }, [dispatch, isOpen]);

   useEffect(() => {
      if (company) {
         const address = company && company.pradr ? company.pradr.addr : {};

         const city = cityList?.find((city) => city?.name?.toLowerCase() === address?.dst?.toLowerCase());
         const state = stateList.find((state) => state.id === city?.stId);

         setRow((prev) => ({
            ...prev,
            name: company?.tradeNam,
            contactPerson: company?.lgnm,
            address1: `${address?.flno} ${address?.bno}, ${address?.bnm} ${address?.st}, ${address?.locality}`,
            cityId: city?.id,
            stateId: state?.id,
            coId: state?.coId,
            pincode: address?.pncd,
            // panNo: prev.gst?.slice(2, 12),
         }));
      }
   }, [cityList, company, stateList]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' || // for react-select input
            activeElement?.isContentEditable;

         if (isTyping) return; // Don't trigger shortcuts while typing

         if (isOpen && e.key.toLowerCase() === 's') {
            e.preventDefault();

            if (e.shiftKey) {
               onsavecontinue(); // SHIFT + S --- save & continue
            } else {
               onFormSubmit(); // S --- Save & Finish
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            handleOnClose(); // c --- cansel
         }
         if (isOpen && e.key.toLowerCase() === 'p') {
            handlePrevious(); // p --- Previous
         }
         if (isOpen && e.key.toLowerCase() === 'n') {
            handleNext(); // n --- next
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   const nameInputRef = useRef();
   const glGroupRef = useRef();

   useEffect(() => {
      if (parentGlGroup && !row.glGroupId && !isEditMode) {
         setRow((prev) => ({ ...prev, glGroupId: parentGlGroup }));
      }
   }, [parentGlGroup, row.glGroupId]);

   useEffect(() => {
      if (demoname && demoname !== '') {
         // setRow((prev) => ({ ...prev, name: demoname }));
         handleInputChange('name', demoname);
      }
      demoname = '';
   }, [demoname, isOpen]);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   useEffect(() => {
      if (activeStep === 1) {
         setTimeout(() => {
            shippingAddress1Ref.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 2) {
         setTimeout(() => {
            lSalesTaxNoRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 3) {
         setTimeout(() => {
            emailRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 4) {
         setTimeout(() => {
            codeRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 5) {
         setTimeout(() => {
            brokerRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleOnClose();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleOnClose]);

   const showPrevTaxes = localStorage.getItem('showPrevTaxes');
   const shouldShowPrevTaxes = showPrevTaxes === 'true';

   const enableCreditLimit = company?.setting?.enableCreditLimit;

   const mobileRef = useRef(null);
   const panNoRef = useRef(null);
   const address1Ref = useRef(null);
   const address2Ref = useRef(null);
   const pincodeRef = useRef(null);
   const cityRef = useRef(null);
   const stateRef = useRef(null);
   const countryRef = useRef(null);
   // const glGroupRef = useRef(null);
   const balanceRef = useRef(null);
   const nextRef = useRef(null);
   const cancelRef = useRef(null);
   const previousRef = useRef(null);
   const shippingAddress1Ref = useRef(null);
   const shippingAddress2Ref = useRef(null);
   const shippingPincodeRef = useRef(null);
   const shippingCityRef = useRef(null);
   const shippingStateRef = useRef(null);
   const shippingCoRef = useRef(null);
   const lSalesTaxNoRef = useRef(null);
   const asseseeTypeRef = useRef(null);
   const eCommMerchantIdRef = useRef(null);
   const itWardNumberRef = useRef(null);
   const licensesTypeRef = useRef(null);
   const serviceTaxDateRef = useRef(null);
   const serviceTaxNoRef = useRef(null);
   const cSalesTaxDateRef = useRef(null);
   const cSalesTaxNumberRef = useRef(null);
   const cstTinDateRef = useRef(null);
   const cstTinNoRef = useRef(null);
   const vatRegDateRef = useRef(null);
   const vatRegNoRef = useRef(null);
   const lSalesTaxDateRef = useRef(null);
   const tdsLimitRef = useRef(null);
   const tdsAccountIdRef = useRef(null);
   const tdsApplicableRef = useRef(null);
   const businessTypeRef = useRef(null);
   const msmeTypeRef = useRef(null);
   const distanceKMRef = useRef(null);
   const locatedInSezRef = useRef(null);
   const udhyogAadharNumberRef = useRef(null);
   const gstRegDateRef = useRef(null);
   const gstRegNoRef = useRef(null);
   const compoundDaysRef = useRef(null);
   const compoundMethodRef = useRef(null);
   const interestRateRef = useRef(null);
   const tdsNatureOfPaymentRef = useRef(null);
   const tdsRateRef = useRef(null);
   const emailRef = useRef(null);
   const bloodGroupRef = useRef(null);
   const birthDateRef = useRef(null);
   const maritalStatusRef = useRef(null);
   const creditLimitDaysRef = useRef(null);
   const creditLimitActionModeRef = useRef(null);
   const creditLimitRef = useRef(null);
   const creditLimitTypeRef = useRef(null);
   const languageNameRef = useRef(null);
   const anniversaryDateRef = useRef(null);
   const priceLevelRef = useRef(null);
   const factPhoneRef = useRef(null);
   const faxRef = useRef(null);
   const contactPersonRef = useRef(null);
   const ownerNameRef = useRef(null);
   const offPhoneRef = useRef(null);
   const resPhoneRef = useRef(null);
   const shortNameRef = useRef(null);
   const aliasNameRef = useRef(null);
   const printNameRef = useRef(null);
   const groupRef = useRef(null);
   const referredByRef = useRef(null);
   const salutationRef = useRef(null);
   const codeRef = useRef(null);
   const parcelRateRef = useRef(null);
   const discForSaleRef = useRef(null);
   const discForPurchaseRef = useRef(null);
   const colorRef = useRef(null);
   const defaultDueDaysRef = useRef(null);
   const extraDueDaysRef = useRef(null);
   const numOfCopiesRef = useRef(null);
   const autoCallOutAdjRef = useRef(null);
   const promptBeforeCallOsadjRef = useRef(null);
   const principalAmtRef = useRef(null);
   const ledgerFolioNoRef = useRef(null);
   const originalValueRef = useRef(null);
   const purchaseDateRef = useRef(null);
   const pnLSharePercentRef = useRef(null);
   const allowChangePriceLevelRef = useRef(null);
   const printOrderRef = useRef(null);
   const depreciationRef = useRef(null);
   const masterRef = useRef(null);
   const broker2Ref = useRef(null);
   const salesRepresentativeRef = useRef(null);
   const deliveryRef = useRef(null);
   const hasteRef = useRef(null);
   const transportRef = useRef(null);
   const bankRef = useRef(null);
   const bankBranchRef = useRef(null);
   const brokerRef = useRef(null);
   const notesRef = useRef(null);
   const notes1Ref = useRef(null);
   const notes2Ref = useRef(null);
   const statusRef = useRef(null);
   const savecontinueRef = useRef(null);
   const sendWhatsAppRef = useRef(null);
   const isBlacklistedRef = useRef(null);
   const syncCodeRef = useRef(null);
   const reasonRef = useRef(null);
   const companyRef = useRef(null);
   const SaveFinishRef = useRef(null);
   const companytypeRef = useRef(null);

   return (
      <>
         <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl" scrollBehavior="inside" overflowY="scroll">
            <ModalOverlay />
            <ModalContent
               bg={useColorModeValue('white', '#2d3748')}
               color={useColorModeValue('gray.800', 'white')}
               borderRadius="20px"
               p={0}
               boxShadow="lg"
               maxHeight="70vh"
               // mx="15px"
               // mx ={{ base: "10px", md: "15px", xl: "15px" }}
               // my={{ base: '8%', md: '10%', xl: '4%' }}
               overflow="auto">
               <ModalHeader
                  className={`
  text-lg font-semibold px-6 py-4 border-b transition-all duration-300
  ${isDark
                        ? 'border-gray-700 bg-gradient-to-r from-gray-900 to-gray-800 text-white'
                        : 'border-blue-200 bg-gradient-to-r from-blue-50 to-white text-gray-800'
                     }
`}>
                  <div className="flex items-center justify-between">
                     <div className="flex items-center space-x-3">
                        <div
                           className={`
        w-2 h-8 rounded-full transition-all duration-300
        ${isDark ? 'bg-blue-500' : 'bg-blue-500'}
      `}
                        />
                        <span>{isEditMode ? 'Edit ' + formType : 'Add New ' + formType}</span>
                     </div>
                  </div>
               </ModalHeader>

               <ModalCloseButton
                  className={`
  top-4 right-4 rounded-lg p-2 transition-all duration-300
  ${isDark
                        ? 'text-gray-400 hover:bg-gray-700 hover:text-white border border-gray-600'
                        : 'text-gray-500 hover:bg-blue-100 hover:text-blue-600 border border-blue-200 bg-white'
                     }
`}
               />
               <ModalBody>
                  <form>
                     <Grid h="auto" templateColumns="repeat(5, 1fr)" gap={4} display="block">
                        <GridItem rowSpan={2} colSpan={1}>
                           <div
                              className={`
                                                  flex overflow-x-auto px-2 md:px-5 xl:px-5 py-3 md:py-3 xl:py-3 mb-3 md:mb-5 xl:mb-5
                                                  border rounded-lg transition-all duration-300
                                                  ${isDark
                                    ? 'border-gray-700 bg-gray-800 shadow-xl'
                                    : 'border-gray-200 bg-white shadow-md'
                                 }
                                                `}>
                              <div className="flex w-full items-center justify-between space-x-1 md:space-x-2">
                                 {steps.map((step, index) => (
                                    <div key={index} className="flex flex-1 items-center">
                                       {/* Step Item */}
                                       <div
                                          onClick={() => setActiveStep(index)}
                                          className={`
                                                            flex flex-col items-center cursor-pointer transition-all duration-300 flex-1
                                                            ${activeStep === index ? 'scale-105' : 'scale-100'}
                                                          `}>
                                          {/* Step Indicator */}
                                          <div
                                             className={`
                                                            flex items-center justify-center rounded-full transition-all duration-300 mb-2
                                                            ${activeStep === index
                                                   ? 'ring-4 ring-opacity-50 transform scale-110'
                                                   : ''
                                                }
                                                            ${index < activeStep
                                                   ? isDark
                                                      ? 'bg-gradient-to-r from-green-500 to-teal-500 text-white'
                                                      : 'bg-gradient-to-r from-green-400 to-teal-400 text-white'
                                                   : activeStep === index
                                                      ? isDark
                                                         ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white ring-blue-500'
                                                         : 'bg-gradient-to-r from-blue-400 to-purple-400 text-white ring-blue-400'
                                                      : isDark
                                                         ? 'bg-gray-700 text-gray-300 border border-gray-600'
                                                         : 'bg-gray-100 text-gray-600 border border-gray-300'
                                                }
                                                            w-5 h-5 md:w-6 md:h-6 xl:w-8 xl:h-8
                                                          `}>
                                             {index < activeStep ? (
                                                <svg
                                                   className="w-3 h-3 md:w-4 md:h-4 xl:w-5 xl:h-5"
                                                   fill="none"
                                                   stroke="currentColor"
                                                   viewBox="0 0 24 24">
                                                   <path
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      strokeWidth={3}
                                                      d="M5 13l4 4L19 7"
                                                   />
                                                </svg>
                                             ) : (
                                                <span
                                                   className={`
                                                                font-semibold
                                                                text-xs md:text-sm xl:text-base
                                                                ${activeStep === index ? 'text-white' : ''}
                                                              `}>
                                                   {index + 1}
                                                </span>
                                             )}
                                          </div>

                                          {/* Step Title */}
                                          <div
                                             className={`
                                                            text-center transition-all duration-300 font-medium
                                                            ${activeStep === index
                                                   ? isDark
                                                      ? 'text-blue-300 font-bold'
                                                      : 'text-blue-600 font-bold'
                                                   : isDark
                                                      ? 'text-gray-400'
                                                      : 'text-gray-500'
                                                }
                                                            text-xs md:text-sm xl:text-sm
                                                            ${activeStep === index ? 'scale-110' : 'scale-100'}
                                                          `}>
                                             {step.title}
                                          </div>
                                       </div>

                                       {/* Step Separator */}
                                       {index < steps.length - 1 && (
                                          <div
                                             className={`
                                                            flex-1 h-0.5 mx-2 transition-all duration-500
                                                            ${index < activeStep
                                                   ? isDark
                                                      ? 'bg-gradient-to-r from-green-500 to-teal-500'
                                                      : 'bg-gradient-to-r from-green-400 to-teal-400'
                                                   : isDark
                                                      ? 'bg-gray-700'
                                                      : 'bg-gray-300'
                                                }
                                                            ${index === activeStep - 1 ? 'scale-110' : 'scale-100'}
                                                          `}
                                          />
                                       )}
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </GridItem>
                        <GridItem colSpan={4}>
                           <Grid
                              templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                              gap={2}>
                              {activeStep === 0 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'gstRegNo',
                                          'GST',
                                          {
                                             value: row.gstRegNo,
                                             onChange: (e) =>
                                                handleInputChange('gstRegNo', e.target.value.toUpperCase()),
                                             ref: gstRegNoRef,
                                             onKeyDown: (e) => {
                                                if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
                                                   nameInputRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                                // Shift+Tab - go to previous field (last field in form)
                                                else if ((e.key === 'Enter' || e.key === 'Tab') && e.shiftKey) {
                                                   SaveFinishRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'name',
                                          'Name',
                                          {
                                             value: row.name,
                                             onChange: (e) => handleInputChange('name', e.target.value),
                                             disabled: isEditMode && isAbs,
                                             ref: nameInputRef,
                                             onKeyDown: (e) => {
                                                if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
                                                   mobileRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                                // Shift+Tab - go to previous field (GST)
                                                else if ((e.key === 'Enter' || e.key === 'Tab') && e.shiftKey) {
                                                   // Focus on GST field (you might need to add a ref for it)
                                                   gstRegNoRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          true,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'mobile',
                                          'Mobile',
                                          {
                                             value: row.mobile,
                                             onChange: (e) => handleInputChange('mobile', e.target.value),
                                             ref: mobileRef,
                                             onKeyDown: (e) => {
                                                if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
                                                   panNoRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                                // Shift+Tab - go to previous field (Name)
                                                else if ((e.key === 'Enter' || e.key === 'Tab') && e.shiftKey) {
                                                   nameInputRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'panNo',
                                          'Pan No',
                                          {
                                             value: row.panNo,
                                             onChange: (e) => handleInputChange('panNo', e.target.value.toUpperCase()),
                                             ref: panNoRef,
                                             onKeyDown: (e) => {
                                                if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
                                                   address1Ref.current?.focus();
                                                   e.preventDefault();
                                                }
                                                // Shift+Tab - go to previous field (Mobile)
                                                else if ((e.key === 'Enter' || e.key === 'Tab') && e.shiftKey) {
                                                   mobileRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'email',
                                          'Email',
                                          {
                                             value: row.email,
                                             onChange: (e) => handleInputChange('email', e.target.value),
                                             ref: emailRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   bloodGroupRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'email',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem colSpan={1} className="seperator-width">
                                       {DynamicInput(
                                          'address1',
                                          'Address 1',
                                          {
                                             value: row.address1,
                                             onChange: (e) => handleInputChange('address1', e.target.value),
                                             ref: address1Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      emailRef.current?.focus();
                                                   } else {
                                                      address2Ref.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem colSpan={1} className="seperator-width">
                                       {DynamicInput(
                                          'address2',
                                          'Address 2',
                                          {
                                             value: row.address2,
                                             onChange: (e) => handleInputChange('address2', e.target.value),
                                             ref: address2Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      address1Ref.current?.focus();
                                                   } else {
                                                      pincodeRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'pincode',
                                          'Pincode',
                                          {
                                             value: row.pincode,
                                             onChange: (e) => handleInputChange('pincode', e.target.value),
                                             ref: pincodeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                   cityRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                                // Shift+Tab - go to previous field (Address)
                                                else if (e.key === 'Tab' && e.shiftKey) {
                                                   address1Ref.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'cityId',
                                          'City',
                                          cityList,
                                          {
                                             value: row.cityId,
                                             onChange: (value) => handleInputChange('cityId', value),
                                             ref: cityRef,
                                             nextRef: Boolean(row.stateId && row.cityId) ? glGroupRef : stateRef,
                                             prevRef: pincodeRef, // Add previous reference
                                             onKeyDown: (e) => {
                                                // Shift+Tab - go to previous field (Pincode)
                                                if (e.key === 'Tab' && e.shiftKey) {
                                                   pincodeRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          ' ',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'stateId',
                                          'State',
                                          stateList,
                                          {
                                             value: row.stateId,
                                             onChange: (value) => handleInputChange('stateId', value),
                                             isDisabled: Boolean(row.stateId && row.cityId),
                                             ref: stateRef,
                                             nextRef: countryRef,
                                             prevRef: cityRef, // Add previous reference
                                             onKeyDown: (e) => {
                                                // Shift+Tab - go to previous field (City)
                                                if (e.key === 'Tab' && e.shiftKey) {
                                                   cityRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select State',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'coId',
                                          'Country',
                                          countryList,
                                          {
                                             value: row.coId,
                                             onChange: (value) => handleInputChange('coId', value),
                                             isDisabled: !!row.stateId,
                                             ref: countryRef,
                                             nextRef: glGroupRef,
                                             prevRef: stateRef, // Add previous reference
                                             onKeyDown: (e) => {
                                                // Shift+Tab - go to previous field (State)
                                                if (e.key === 'Tab' && e.shiftKey) {
                                                   stateRef.current?.focus();
                                                   e.preventDefault();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Country',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'companyType',
                                          'Company Type',
                                          COMPANY_TYPE,
                                          {
                                             value: row.companyType,
                                             onChange: (value) => handleInputChange('companyType', value),
                                             ref: companytypeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      countryRef.current?.focus();
                                                   } else {
                                                      if (shouldSendCompanyidAccount) {
                                                         glGroupRef.current?.focus();
                                                      } else {
                                                         balanceRef.current?.focus();
                                                      }
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Company Type',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'glGroupId',
                                          'User Type',
                                          getGLGroupsList,
                                          {
                                             value: row.glGroupId,
                                             onChange: (value) => {
                                                const selectedOption = getGLGroupsList?.find(
                                                   (item) => item.id === value,
                                                );
                                                handleInputChange('glGroupId', value);
                                                if (selectedOption?.code) {
                                                   handleInputChange('glGroupCode', selectedOption.code);
                                                }
                                             },
                                             ref: glGroupRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      companytypeRef.current?.focus();
                                                   } else {
                                                      if (shouldSendCompanyidAccount) {
                                                         udhyogAadharNumberRef.current?.focus();
                                                      } else {
                                                         companyRef.current?.focus();
                                                      }
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select User Type',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'udhyogAadharNumber',
                                          'Udhyog Aadhar Number',
                                          {
                                             value: row.udhyogAadharNumber,
                                             onChange: (e) => handleInputChange('udhyogAadharNumber', e.target.value),
                                             ref: udhyogAadharNumberRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      glGroupRef.current?.focus();
                                                   } else {
                                                      if (shouldSendCompanyidAccount) {
                                                         companyRef.current?.focus();
                                                      } else {
                                                         balanceRef.current?.focus();
                                                      }
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    {shouldSendCompanyidAccount && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicUiDropdown(
                                             'company',
                                             'Company',
                                             lastcompanyOptions,
                                             {
                                                value: row.compIds,
                                                onChange: handleCompanyChange,
                                                ref: companyRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                      e.preventDefault();
                                                      SaveFinishRef.current?.focus();
                                                   }
                                                   // Shift+Tab - go to previous field (Balance)
                                                   else if (e.key === 'Tab' && e.shiftKey) {
                                                      balanceRef.current?.focus();
                                                      e.preventDefault();
                                                   }
                                                },
                                                prevRef: balanceRef, // Add previous reference
                                             },
                                             {},
                                             textColor,
                                             false,
                                             'Select company',
                                             true,
                                             undefined,
                                             true,
                                          )}
                                       </GridItem>
                                    )}

                                    <GridItem className="seperator-width" display="flex">
                                       <GridItem className="seperator-width" width="80%">
                                          {DynamicInput(
                                             'balance',
                                             'Balance',
                                             {
                                                value: row.balance,
                                                onChange: (e) => handleInputChange('balance', e.target.value),
                                                ref: balanceRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                      e.preventDefault();
                                                      if (shouldSendCompanyidAccount) {
                                                         companyRef.current?.focus();
                                                      } else {
                                                         SaveFinishRef.current?.focus();
                                                      }
                                                   }
                                                   // Shift+Tab - go to previous field (User Type)
                                                   else if (e.key === 'Tab' && e.shiftKey) {
                                                      glGroupRef.current?.focus();
                                                      e.preventDefault();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             'number',
                                             false,
                                          )}
                                       </GridItem>

                                       {/* CR/DR Badge */}
                                       <GridItem
                                          className="seperator-width"
                                          width="20%"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center">
                                          <Box
                                             px={3}
                                             py={1}
                                             borderRadius="md"
                                             bg={
                                                row.balanceType
                                                   ? row.balanceType === 'payable'
                                                      ? 'red.500'
                                                      : 'green.500'
                                                   : 'red.500'
                                             }
                                             color="white"
                                             fontWeight="bold"
                                             textAlign="center"
                                             boxShadow="md">
                                             {row.balanceType ? (row.balanceType === 'payable' ? 'CR' : 'DR') : 'CR'}
                                          </Box>
                                       </GridItem>
                                    </GridItem>

                                    <GridItem colSpan={{ base: 1, md: 2, xl: 2 }} display="flex" alignItems="center">
                                       <Text fontSize={{ base: '12px', md: '16px', xl: '18px' }} mr={3}>
                                          Opening Balance :
                                       </Text>
                                       <Controller
                                          name="balanceType"
                                          control={control}
                                          defaultValue="payable"
                                          render={({ field }) => (
                                             <RadioGroup
                                                value={row.balanceType || 'payable'}
                                                onChange={(newValue) => {
                                                   field.onChange(newValue);
                                                   handleInputChange('balanceType', newValue);
                                                }}>
                                                <Stack spacing={2} direction="row">
                                                   <Radio colorScheme="orange" value="payable">
                                                      <Text fontSize={{ base: '10px', md: '14px', xl: '16px' }}>
                                                         Payable
                                                      </Text>
                                                   </Radio>
                                                   <Radio colorScheme="green" value="receivable">
                                                      <Text fontSize={{ base: '10px', md: '14px', xl: '16px' }}>
                                                         Receivable
                                                      </Text>
                                                   </Radio>
                                                </Stack>
                                             </RadioGroup>
                                          )}
                                       />
                                    </GridItem>

                                    <GridItem colSpan={{ base: 1, md: 3, xl: 3 }}>
                                       <Checkbox isChecked={isSameAddress} onChange={handleSameAddressChange}>
                                          Shipping Address Same as above
                                       </Checkbox>
                                    </GridItem>
                                    {/* Only render the following fields if the "Shipping Address Same as above" is unchecked */}
                                    <GridItem colSpan={1}>
                                       {DynamicInput(
                                          'shippingAddress1',
                                          'Shipping Address 1',
                                          {
                                             value: row.shippingAddress1,
                                             onChange: (e) => handleInputChange('shippingAddress1', e.target.value),
                                             ref: shippingAddress1Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      balanceRef.current?.focus();
                                                   } else {
                                                      shippingAddress2Ref.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem colSpan={1}>
                                       {DynamicInput(
                                          'shippingAddress2',
                                          'Shipping Address 2',
                                          {
                                             value: row.shippingAddress2,
                                             onChange: (e) => handleInputChange('shippingAddress2', e.target.value),
                                             ref: shippingAddress2Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      shippingAddress1Ref.current?.focus();
                                                   } else {
                                                      shippingPincodeRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem colSpan={1}>
                                       {DynamicInput(
                                          'shippingPincode',
                                          'Shipping Pincode',
                                          {
                                             value: row.shippingPincode,
                                             onChange: (e) => handleInputChange('shippingPincode', e.target.value),
                                             ref: shippingPincodeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   shippingCityRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem colSpan={{ base: 1, md: 3, xl: 3 }}>
                                       <Grid
                                          templateColumns={{
                                             base: 'repeat(1, 1fr)',
                                             md: 'repeat(3, 1fr)',
                                             xl: 'repeat(3, 1fr)',
                                          }}
                                          gap={2}>
                                          <GridItem>
                                             {renderDynamicDropdown(
                                                'shippingCityId',
                                                'Shipping City',
                                                cityList,
                                                {
                                                   value: row.shippingCityId,
                                                   onChange: (value) => handleInputChange('shippingCityId', value),
                                                   disabled: isSameAddress,
                                                   showCustomNoOptions: true,
                                                   openfrom: 'city',
                                                   ref: shippingCityRef,
                                                   nextRef: shippingStateRef,
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select City',
                                             )}
                                          </GridItem>
                                          <GridItem>
                                             {renderDynamicDropdown(
                                                'shippingStateId',
                                                'Shipping State',
                                                stateList,
                                                {
                                                   value: row.shippingStateId,
                                                   onChange: (value) => handleInputChange('shippingStateId', value),
                                                   isDisabled: Boolean(row.shippingStateId && row.shippingCityId),
                                                   showCustomNoOptions: true,
                                                   openfrom: 'state',
                                                   ref: shippingStateRef,
                                                   nextRef: shippingCoRef,
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select State',
                                             )}
                                          </GridItem>
                                          <GridItem>
                                             {renderDynamicDropdown(
                                                'shippingCoId',
                                                'Shipping Country',
                                                countryList,
                                                {
                                                   value: row.shippingCoId,
                                                   onChange: (value) => handleInputChange('shippingCoId', value),
                                                   isDisabled: !!row.shippingStateId,
                                                   showCustomNoOptions: true,
                                                   openfrom: 'country',
                                                   ref: shippingCoRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         SaveFinishRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Country',
                                                false,
                                             )}
                                          </GridItem>
                                       </Grid>
                                    </GridItem>
                                 </>
                              )}

                              {activeStep === 1 && (
                                 <>
                                    {shouldShowPrevTaxes && (
                                       <>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'lSalesTaxNo',
                                                'l Sales TaxNo',
                                                {
                                                   value: row.lSalesTaxNo,
                                                   onChange: (e) => handleInputChange('lSalesTaxNo', e.target.value),
                                                   ref: lSalesTaxNoRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         lSalesTaxDateRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'lSalesTaxDate',
                                                'l Sales Tax Date',
                                                {
                                                   value: row.lSalesTaxDate,
                                                   onChange: (e) => handleInputChange('lSalesTaxDate', e.target.value),
                                                   ref: lSalesTaxDateRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         vatRegNoRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'date',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'vatRegNo',
                                                'Vat Reg No',
                                                {
                                                   value: row.vatRegNo,
                                                   onChange: (e) => handleInputChange('vatRegNo', e.target.value),
                                                   ref: vatRegNoRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         vatRegDateRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'vatRegDate',
                                                'Vat Reg Date',
                                                {
                                                   value: row.vatRegDate,
                                                   onChange: (e) => handleInputChange('vatRegDate', e.target.value),
                                                   ref: vatRegDateRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         cstTinNoRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'date',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'cstTinNo',
                                                'cstTin No',
                                                {
                                                   value: row.cstTinNo,
                                                   onChange: (e) => handleInputChange('cstTinNo', e.target.value),
                                                   ref: cstTinNoRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         cstTinDateRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'cstTinDate',
                                                'cstTin Date',
                                                {
                                                   value: row.cstTinDate,
                                                   onChange: (e) => handleInputChange('cstTinDate', e.target.value),
                                                   ref: cstTinDateRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         cSalesTaxNumberRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'date',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'cSalesTaxNumber',
                                                'cSales Tax Number',
                                                {
                                                   value: row.cSalesTaxNumber,
                                                   onChange: (e) =>
                                                      handleInputChange('cSalesTaxNumber', e.target.value),
                                                   ref: cSalesTaxNumberRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         cSalesTaxDateRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'cSalesTaxDate',
                                                'cSales Tax Date',
                                                {
                                                   value: row.cSalesTaxDate,
                                                   onChange: (e) => handleInputChange('cSalesTaxDate', e.target.value),
                                                   ref: cSalesTaxDateRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         serviceTaxNoRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'date',
                                                false,
                                             )}
                                          </GridItem>
                                       </>
                                    )}
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'serviceTaxNo',
                                          'Service Tax No',
                                          {
                                             value: row.serviceTaxNo,
                                             onChange: (e) => handleInputChange('serviceTaxNo', e.target.value),
                                             ref: serviceTaxNoRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   serviceTaxDateRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'serviceTaxDate',
                                          'Service Tax Date',
                                          {
                                             value: row.serviceTaxDate,
                                             onChange: (e) => handleInputChange('serviceTaxDate', e.target.value),
                                             ref: serviceTaxDateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   licensesTypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'date',
                                          false,
                                       )}
                                    </GridItem>
                                    {/* <GridItem className="seperator-width">
                                                                     {renderDynamicDropdown(
                                                                        'licensesType',
                                                                        'Licenses Type',
                                                                        LicensesType,
                                                                        {
                                                                           value: row.licensesType,
                                                                           onChange: (value) => handleInputChange('licensesType', value),
                                                                           ref: licensesTypeRef,
                                                                           onKeyDown: (e) => {
                                                                              if (e.key === 'Enter' || e.key === 'Tab') {
                                                                                 e.preventDefault();
                                                                                 itWardNumberRef.current?.focus();
                                                                              }
                                                                           },
                                                                        },
                                                                        errors,
                                                                        textColor,
                                                                        false,
                                                                        'Select Licenses Type',
                                                                     )}
                                                                  </GridItem> 
                                                                  <GridItem className="seperator-width">
                                                                     {DynamicInput(
                                                                        'itWardNumber',
                                                                        'ItWard Number',
                                                                        {
                                                                           value: row.itWardNumber,
                                                                           onChange: (e) => handleInputChange('itWardNumber', e.target.value),
                                                                           ref: itWardNumberRef,
                                                                           onKeyDown: (e) => {
                                                                              if (e.key === 'Enter' || e.key === 'Tab') {
                                                                                 e.preventDefault();
                                                                                 eCommMerchantIdRef.current?.focus();
                                                                              }
                                                                           },
                                                                        },
                                                                        errors,
                                                                        textColor,
                                                                        'text',
                                                                        false,
                                                                     )}
                                                                  </GridItem>
                                                                  <GridItem className="seperator-width">
                                                                     {DynamicInput(
                                                                        'eCommMerchantId',
                                                                        'eComm MerchantId',
                                                                        {
                                                                           value: row.eCommMerchantId,
                                                                           onChange: (e) => handleInputChange('eCommMerchantId', e.target.value),
                                                                           ref: eCommMerchantIdRef,
                                                                           onKeyDown: (e) => {
                                                                              if (e.key === 'Enter' || e.key === 'Tab') {
                                                                                 e.preventDefault();
                                                                                 asseseeTypeRef.current?.focus();
                                                                              }
                                                                           },
                                                                        },
                                                                        errors,
                                                                        textColor,
                                                                        'text',
                                                                        false,
                                                                     )}
                                                                  </GridItem>*/}
                                    {/* <GridItem className="seperator-width">
                                                                     {DynamicInput(
                                                                        'distanceKM',
                                                                        'Distance KM',
                                                                        {
                                                                           value: row.distanceKM,
                                                                           onChange: (e) => handleInputChange('distanceKM', e.target.value),
                                                                           ref: distanceKMRef,
                                                                           onKeyDown: (e) => {
                                                                              if (e.key === 'Enter' || e.key === 'Tab') {
                                                                                 e.preventDefault();
                                                                                 msmeTypeRef.current?.focus();
                                                                              }
                                                                           },
                                                                        },
                                                                        errors,
                                                                        textColor,
                                                                        'number',
                                                                        false,
                                                                     )}
                                                                  </GridItem> */}
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'msmeType',
                                          'Msme Type',
                                          MSME_TYPE,
                                          {
                                             value: row.msmeType,
                                             onChange: (value) => handleInputChange('msmeType', value),
                                             ref: msmeTypeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   businessTypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Msme Type',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'businessType',
                                          'Business Type',
                                          BUSINESS_TYPE,
                                          {
                                             value: row.businessType,
                                             onChange: (value) => handleInputChange('businessType', value),
                                             ref: businessTypeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   tdsApplicableRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Business Type',
                                       )}
                                    </GridItem>
                                    {['0', '4', 'H', 'O', 'F', 'A', 'L', 'C', 'D', 'N', 'M', 'E', 'K'].includes(
                                       row.glGroupCode,
                                    ) && (
                                          <>
                                             <GridItem className="seperator-width">
                                                {renderSwitchControl(
                                                   'tdsApplicable',
                                                   'TDS Applicable',
                                                   {
                                                      isChecked: row.tdsApplicable,
                                                      onChange: handleSwitchChange('tdsApplicable'),
                                                      ref: tdsApplicableRef,
                                                      onKeyDown: (e) => {
                                                         if (e.key === 'Enter' || e.key === 'Tab') {
                                                            e.preventDefault();
                                                            tdsAccountIdRef.current?.focus();
                                                         }
                                                      },
                                                   },
                                                   errors,
                                                   textColor,
                                                   false,
                                                   false,
                                                )}
                                             </GridItem>
                                             <GridItem className="seperator-width">
                                                {renderDynamicDropdown(
                                                   'tdsAccountId',
                                                   'TDS Account',
                                                   accountList,
                                                   {
                                                      value: row.tdsAccountId,
                                                      onChange: (value) => handleInputChange('tdsAccountId', value),
                                                      ref: tdsAccountIdRef,
                                                      onKeyDown: (e) => {
                                                         if (e.key === 'Enter' || e.key === 'Tab') {
                                                            e.preventDefault();
                                                            tdsLimitRef.current?.focus();
                                                         }
                                                      },
                                                   },
                                                   errors,
                                                   textColor,
                                                   false,
                                                   'Select TDS Account',
                                                )}
                                             </GridItem>
                                             <GridItem className="seperator-width">
                                                {DynamicInput(
                                                   'tdsLimit',
                                                   'TDS Limit',
                                                   {
                                                      value: row.tdsLimit,
                                                      onChange: (e) => handleInputChange('tdsLimit', e.target.value),
                                                      ref: tdsLimitRef,
                                                      onKeyDown: (e) => {
                                                         if (e.key === 'Enter' || e.key === 'Tab') {
                                                            e.preventDefault();
                                                            tdsRateRef.current?.focus();
                                                         }
                                                      },
                                                   },
                                                   errors,
                                                   textColor,
                                                   'number',
                                                   false,
                                                )}
                                             </GridItem>
                                             <GridItem className="seperator-width">
                                                {DynamicInput(
                                                   'tdsRate',
                                                   'TDS Rate',
                                                   {
                                                      value: row.tdsRate,
                                                      onChange: (e) => handleInputChange('tdsRate', e.target.value),
                                                      ref: tdsRateRef,
                                                      onKeyDown: (e) => {
                                                         if (e.key === 'Enter' || e.key === 'Tab') {
                                                            e.preventDefault();
                                                            tdsNatureOfPaymentRef.current?.focus();
                                                         }
                                                      },
                                                   },
                                                   errors,
                                                   textColor,
                                                   'number',
                                                   false,
                                                )}
                                             </GridItem>
                                             <GridItem className="seperator-width">
                                                {DynamicInput(
                                                   'tdsNatureOfPayment',
                                                   'TDS Nature of Payment',
                                                   {
                                                      value: row.tdsNatureOfPayment,
                                                      onChange: (e) =>
                                                         handleInputChange('tdsNatureOfPayment', e.target.value),
                                                      ref: tdsNatureOfPaymentRef,
                                                      onKeyDown: (e) => {
                                                         if (e.key === 'Enter' || e.key === 'Tab') {
                                                            e.preventDefault();
                                                            interestRateRef.current?.focus();
                                                         }
                                                      },
                                                   },
                                                   errors,
                                                   textColor,
                                                   'text',
                                                   false,
                                                )}
                                             </GridItem>
                                          </>
                                       )}
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'interestRate',
                                          'Interest Rate',
                                          {
                                             value: row.interestRate,
                                             onChange: (e) => handleInputChange('interestRate', e.target.value),
                                             ref: interestRateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   compoundMethodRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'compoundMethod',
                                          'Compound Method',
                                          COMPOUND_METHOD,
                                          {
                                             value: row.compoundMethod,
                                             onChange: (value) => handleInputChange('compoundMethod', value),
                                             ref: compoundMethodRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   compoundDaysRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select TDS Account',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'compoundDays',
                                          'Compound Days',
                                          {
                                             value: row.compoundDays,
                                             onChange: (e) => handleInputChange('compoundDays', e.target.value),
                                             ref: compoundDaysRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   SaveFinishRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                 </>
                              )}

                              {activeStep === 2 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'bloodGroup',
                                          'Blood Group',
                                          BLOOD_GROUP,
                                          {
                                             value: row.bloodGroup,
                                             onChange: (value) => handleInputChange('bloodGroup', value),
                                             ref: bloodGroupRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   birthDateRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Blood Group',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'birthDate',
                                          'Birth Date',
                                          {
                                             value: row.birthDate,
                                             onChange: (e) => handleInputChange('birthDate', e.target.value),
                                             ref: birthDateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   maritalStatusRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'date',
                                          false,
                                       )}
                                    </GridItem>
                                    {/* <GridItem>
              {renderSelectFormControl(
                'maritalStatus',
                'Marital Status',
                MARITAL_STATUS,
                {
                  value: row.maritalStatus,
                  onChange: (e) =>
                    handleInputChange(
                      'maritalStatus',
                      e.target.value,
                    ),
                },
                errors,
                textColor,
                false,
                'Select Marital Status',
              )}
            </GridItem> */}

                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'maritalStatus',
                                          'Marital Status',
                                          {
                                             isChecked: row.maritalStatus,
                                             onChange: handleSwitchChange('maritalStatus'),
                                             ref: maritalStatusRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   anniversaryDateRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'anniversaryDate',
                                          'Anniversary Date',
                                          {
                                             value: row.anniversaryDate,
                                             onChange: (e) => handleInputChange('anniversaryDate', e.target.value),
                                             ref: anniversaryDateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   languageNameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'date',
                                          false,
                                       )}
                                    </GridItem>
                                    {/* <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'languageName',
                                          'Language Name',
                                          {
                                             value: row.languageName,
                                             onChange: (e) => handleInputChange('languageName', e.target.value),
                                             ref: languageNameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   creditLimitTypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem> */}
                                    {enableCreditLimit && (
                                       <>
                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'creditLimitType',
                                                'Credit Limit Type',
                                                CREDIT_LIMIT_TYPE,
                                                {
                                                   value: row.creditLimitType,
                                                   onChange: (value) => handleInputChange('creditLimitType', value),
                                                   ref: creditLimitTypeRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         creditLimitRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Credit Limit Type',
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'creditLimit',
                                                'Credit Limit',
                                                {
                                                   value: row.creditLimit,
                                                   onChange: (e) => handleInputChange('creditLimit', e.target.value),
                                                   ref: creditLimitRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         creditLimitActionModeRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'creditLimitActionMode',
                                                'Credit Limit Action Mode',
                                                ActionMode,
                                                {
                                                   value: row.creditLimitActionMode,
                                                   onChange: (value) =>
                                                      handleInputChange('creditLimitActionMode', value),
                                                   ref: creditLimitActionModeRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         creditLimitDaysRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Credit Limit Action Mode',
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'creditLimitDays',
                                                'Credit Limit Days',
                                                {
                                                   value: row.creditLimitDays,
                                                   onChange: (e) =>
                                                      handleInputChange('creditLimitDays', e.target.value),
                                                   ref: creditLimitDaysRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         SaveFinishRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>
                                       </>
                                    )}

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'brokerId',
                                          'Broker Id',
                                          accountList,
                                          {
                                             value: row.brokerId,
                                             onChange: (value) => handleInputChange('brokerId', value),
                                             ref: brokerRef,
                                             nextRef: transportRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Broker Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'transportId',
                                          'Transport',
                                          transportData,
                                          {
                                             value: row.transportId,
                                             onChange: (value) => handleInputChange('transportId', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'transport',
                                             ref: transportRef,
                                             nextRef: bankRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Transport',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {/* Change */}
                                       {renderDynamicDropdown(
                                          'bankId',
                                          'Bank',
                                          bankData,
                                          {
                                             value: row.bankId,
                                             onChange: (value) => handleInputChange('bankId', value),
                                             ref: bankRef,
                                             nextRef: bankBranchRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Bank',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'bankBranchId',
                                          'Bank Branch',
                                          bankBranchData,
                                          {
                                             value: row.bankBranchId,
                                             onChange: (value) => handleInputChange('bankBranchId', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'bankBranch',
                                             ref: bankBranchRef,
                                             nextRef: salesRepresentativeRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Bank Branch',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'salesRepresentativeId',
                                          'Sales Representative',
                                          salesRepresentativeData,
                                          {
                                             value: row.salesRepresentativeId,
                                             onChange: (value) => handleInputChange('salesRepresentativeId', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'salesRepresentative',
                                             ref: salesRepresentativeRef,
                                             nextRef: broker2Ref,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Sales Representative',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'broker2Id',
                                          'broker2 Id',
                                          accountList,
                                          {
                                             value: row.broker2Id,
                                             onChange: (value) => handleInputChange('broker2Id', value),
                                             ref: broker2Ref,
                                             nextRef: deliveryRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select broker2 Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'deliveryId',
                                          'Delivery Id',
                                          accountList,
                                          {
                                             value: row.deliveryId,
                                             onChange: (value) => handleInputChange('deliveryId', value),
                                             ref: deliveryRef,
                                             nextRef: hasteRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Delivery Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'hasteId',
                                          'Haste Id',
                                          accountList,
                                          {
                                             value: row.hasteId,
                                             onChange: (value) => handleInputChange('hasteId', value),
                                             ref: hasteRef,
                                             nextRef: masterRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Haste Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'masterId',
                                          'Master Id',
                                          accountList,
                                          {
                                             value: row.masterId,
                                             onChange: (value) => handleInputChange('masterId', value),
                                             ref: masterRef,
                                             nextRef: notesRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Master Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'notes',
                                          'Notes',
                                          {
                                             value: row.notes,
                                             onChange: (e) => handleInputChange('notes', e.target.value),
                                             ref: notesRef,
                                             nextRef: notes1Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   notes1Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'notes1',
                                          'Notes1',
                                          {
                                             value: row.notes1,
                                             onChange: (e) => handleInputChange('notes1', e.target.value),
                                             ref: notes1Ref,
                                             nextRef: notes2Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   notes2Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'notes2',
                                          'Notes2',
                                          {
                                             value: row.notes2,
                                             onChange: (e) => handleInputChange('notes2', e.target.value),
                                             ref: notes2Ref,
                                             nextRef: statusRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   statusRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'status',
                                          'Status',
                                          {
                                             isChecked: row.status,
                                             onChange: handleSwitchChange('status'),
                                             ref: statusRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   isBlacklistedRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isBlacklisted',
                                          'Blacklisted',
                                          {
                                             isChecked: row.isBlacklisted,
                                             onChange: handleSwitchChange('isBlacklisted'),
                                             ref: isBlacklistedRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (row.isBlacklisted) {
                                                      // If blacklisted is ON, focus on reason field
                                                      reasonRef.current?.focus();
                                                   } else if (row.glGroupId === 18 || row.glGroupId === 12) {
                                                      syncCodeRef.current?.focus();
                                                   } else {
                                                      sendWhatsAppRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>

                                    {row.isBlacklisted && (
                                       <GridItem className="seperator-width">
                                          {DynamicInput(
                                             'reason',
                                             'Reason For Blacklisting',
                                             {
                                                value: row.reason,
                                                onChange: (e) => handleInputChange('reason', e.target.value),
                                                ref: reasonRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      syncCodeRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             'text',
                                             false,
                                          )}
                                       </GridItem>
                                    )}
                                    {(row.glGroupCode && ['E', 'K'].includes(row.glGroupCode)) ||
                                       (row.glGroupId &&
                                          getGLGroupsList?.find((item) => item.id === row.glGroupId)?.code &&
                                          ['E', 'K'].includes(
                                             getGLGroupsList.find((item) => item.id === row.glGroupId).code,
                                          )) ? (
                                       <GridItem className="seperator-width">
                                          {DynamicInput(
                                             'syncCode',
                                             'Sync Code',
                                             {
                                                value: row.syncCode,
                                                onChange: (e) => handleInputChange('syncCode', e.target.value),
                                                ref: syncCodeRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      sendWhatsAppRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             'text',
                                             false,
                                          )}
                                       </GridItem>
                                    ) : null}
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'sendWhatsApp',
                                          'Send WhatsApp',
                                          {
                                             isChecked: row.sendWhatsApp,
                                             onChange: handleSwitchChange('sendWhatsApp'),
                                             ref: sendWhatsAppRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   savecontinueRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 </>
                              )}

                              {activeStep === 3 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'code',
                                          'Code',
                                          {
                                             value: row.code,
                                             onChange: (e) => handleInputChange('code', e.target.value),
                                             ref: codeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   groupRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {/* Change on Edit can't same the account */}
                                       {renderDynamicDropdown(
                                          'groupId',
                                          'Group ID',
                                          accountList,
                                          {
                                             value: row.groupId,
                                             onChange: (value) => handleInputChange('groupId', value),
                                             ref: groupRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   referredByRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Group ID',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'referredById',
                                          'Referred By',
                                          accountList,
                                          {
                                             value: row.referredById,
                                             onChange: (value) => handleInputChange('referredById', value),
                                             ref: referredByRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   salutationRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Referred By',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'salutation',
                                          'Salutation',
                                          {
                                             value: row.salutation,
                                             onChange: (e) => handleInputChange('salutation', e.target.value),
                                             ref: salutationRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   shortNameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'shortName',
                                          'Short Name',
                                          {
                                             value: row.shortName,
                                             onChange: (e) => handleInputChange('shortName', e.target.value),
                                             ref: shortNameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   aliasNameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'aliasName',
                                          'Alias Name',
                                          {
                                             value: row.aliasName,
                                             onChange: (e) => handleInputChange('aliasName', e.target.value),
                                             ref: aliasNameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   printNameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'printName',
                                          'Print Name',
                                          {
                                             value: row.printName,
                                             onChange: (e) => handleInputChange('printName', e.target.value),
                                             ref: printNameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   ownerNameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'ownerName',
                                          'Owner Name',
                                          {
                                             value: row.ownerName,
                                             onChange: (e) => handleInputChange('ownerName', e.target.value),
                                             ref: ownerNameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   offPhoneRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'offPhone',
                                          'Office Phone',
                                          {
                                             value: row.offPhone,
                                             onChange: (e) => {
                                                // Allow numbers and specific special characters only
                                                const value = e.target.value.replace(/[^0-9+\-(). ]/g, '');
                                                handleInputChange('offPhone', value);
                                             },
                                             ref: offPhoneRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   resPhoneRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'resPhone',
                                          'Residence Phone',
                                          {
                                             value: row.resPhone,
                                             onChange: (e) => {
                                                const value = e.target.value.replace(/[^0-9+\-(). ]/g, '');
                                                handleInputChange('resPhone', value);
                                             },
                                             ref: resPhoneRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   factPhoneRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'factPhone',
                                          'Factory Phone',
                                          {
                                             value: row.factPhone,
                                             onChange: (e) => {
                                                const value = e.target.value.replace(/[^0-9+\-(). ]/g, '');
                                                handleInputChange('factPhone', value);
                                             },
                                             ref: factPhoneRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   faxRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'fax',
                                          'Fax',
                                          {
                                             value: row.fax,
                                             onChange: (e) => handleInputChange('fax', e.target.value),
                                             ref: faxRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   contactPersonRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'contactPerson',
                                          'Contact Person',
                                          {
                                             value: row.contactPerson,
                                             onChange: (e) => handleInputChange('contactPerson', e.target.value),
                                             ref: contactPersonRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   priceLevelRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'priceLevel',
                                          'Price Level',
                                          PRICE_LEVELS,
                                          {
                                             value: row.priceLevel,
                                             onChange: (value) => handleInputChange('priceLevel', value),
                                             ref: priceLevelRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   allowChangePriceLevelRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Price Level',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'allowChangePriceLevel',
                                          'Allow Change Price Level',
                                          {
                                             isChecked: row.allowChangePriceLevel,
                                             onChange: handleSwitchChange('allowChangePriceLevel'),
                                             ref: allowChangePriceLevelRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   printOrderRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'printOrder',
                                          'Print Order',
                                          {
                                             value: row.printOrder,
                                             onChange: (e) => handleInputChange('printOrder', e.target.value),
                                             ref: printOrderRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   depreciationRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'depreciation',
                                          'Depreciation',
                                          {
                                             value: row.depreciation,
                                             onChange: (e) => handleInputChange('depreciation', e.target.value),
                                             ref: depreciationRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   originalValueRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'originalValue',
                                          'Original Value',
                                          {
                                             value: row.originalValue,
                                             onChange: (e) => handleInputChange('originalValue', e.target.value),
                                             ref: originalValueRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   purchaseDateRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'purchaseDate',
                                          'Purchase Date',
                                          {
                                             value: row.purchaseDate,
                                             onChange: (e) => handleInputChange('purchaseDate', e.target.value),
                                             ref: purchaseDateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   pnLSharePercentRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'date',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'pnLSharePercent',
                                          'pnL Share Percent',
                                          {
                                             value: row.pnLSharePercent,
                                             onChange: (e) => handleInputChange('pnLSharePercent', e.target.value),
                                             ref: pnLSharePercentRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   ledgerFolioNoRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'ledgerFolioNo',
                                          'Ledger Folio No',
                                          {
                                             value: row.ledgerFolioNo,
                                             onChange: (e) => handleInputChange('ledgerFolioNo', e.target.value),
                                             ref: ledgerFolioNoRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   autoCallOutAdjRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'autoCallOutAdj',
                                          'Auto CallOut Adj',
                                          {
                                             isChecked: row.autoCallOutAdj,
                                             onChange: handleSwitchChange('autoCallOutAdj'),
                                             ref: autoCallOutAdjRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   promptBeforeCallOsadjRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'promptBeforeCallOsadj',
                                          'Prompt Before Call Osadj',
                                          {
                                             isChecked: row.promptBeforeCallOsadj,
                                             onChange: handleSwitchChange('promptBeforeCallOsadj'),
                                             ref: promptBeforeCallOsadjRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   principalAmtRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'principalAmt',
                                          'Principal Amt',
                                          {
                                             value: row.principalAmt,
                                             onChange: (e) => handleInputChange('principalAmt', e.target.value),
                                             ref: principalAmtRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   defaultDueDaysRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'defaultDueDays',
                                          'Default Due Days',
                                          {
                                             value: row.defaultDueDays,
                                             onChange: (e) => handleInputChange('defaultDueDays', e.target.value),
                                             ref: defaultDueDaysRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   extraDueDaysRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'extraDueDays',
                                          'Extra Due Days',
                                          {
                                             value: row.extraDueDays,
                                             onChange: (e) => handleInputChange('extraDueDays', e.target.value),
                                             ref: extraDueDaysRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   numOfCopiesRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'numOfCopies',
                                          'Number Of Copies',
                                          {
                                             value: row.numOfCopies,
                                             onChange: (e) => handleInputChange('numOfCopies', e.target.value),
                                             ref: numOfCopiesRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   colorRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderFormControl(
                                          'color',
                                          'Color',
                                          {
                                             value: row.color,
                                             onChange: (e) => handleInputChange('color', e.target.value),
                                             ref: colorRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   parcelRateRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'color',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'parcelRate',
                                          'Parcel Rate',
                                          {
                                             value: row.parcelRate,
                                             onChange: (e) => handleInputChange('parcelRate', e.target.value),
                                             ref: parcelRateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   discForSaleRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'discForSale',
                                          'Disc For Sale',
                                          {
                                             value: row.discForSale,
                                             onChange: (e) => handleInputChange('discForSale', e.target.value),
                                             ref: discForSaleRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   discForPurchaseRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'discForPurchase',
                                          'Disc For Purchase',
                                          {
                                             value: row.discForPurchase,
                                             onChange: (e) => handleInputChange('discForPurchase', e.target.value),
                                             ref: discForPurchaseRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   SaveFinishRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                 </>
                              )}

                              {/* {activeStep === 4 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'brokerId',
                                          'Broker Id',
                                          accountList,
                                          {
                                             value: row.brokerId,
                                             onChange: (value) => handleInputChange('brokerId', value),
                                             ref: brokerRef,
                                             nextRef: transportRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Broker Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'transportId',
                                          'Transport',
                                          transportData,
                                          {
                                             value: row.transportId,
                                             onChange: (value) => handleInputChange('transportId', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'transport',
                                             ref: transportRef,
                                             nextRef: bankRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Transport',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'bankId',
                                          'Bank',
                                          bankData,
                                          {
                                             value: row.bankId,
                                             onChange: (value) => handleInputChange('bankId', value),
                                             ref: bankRef,
                                             nextRef: bankBranchRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Bank',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'bankBranchId',
                                          'Bank Branch',
                                          bankBranchData,
                                          {
                                             value: row.bankBranchId,
                                             onChange: (value) => handleInputChange('bankBranchId', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'bankBranch',
                                             ref: bankBranchRef,
                                             nextRef: salesRepresentativeRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Bank Branch',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'salesRepresentativeId',
                                          'Sales Representative',
                                          salesRepresentativeData,
                                          {
                                             value: row.salesRepresentativeId,
                                             onChange: (value) => handleInputChange('salesRepresentativeId', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'salesRepresentative',
                                             ref: salesRepresentativeRef,
                                             nextRef: broker2Ref,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Sales Representative',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'broker2Id',
                                          'broker2 Id',
                                          accountList,
                                          {
                                             value: row.broker2Id,
                                             onChange: (value) => handleInputChange('broker2Id', value),
                                             ref: broker2Ref,
                                             nextRef: deliveryRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select broker2 Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'deliveryId',
                                          'Delivery Id',
                                          accountList,
                                          {
                                             value: row.deliveryId,
                                             onChange: (value) => handleInputChange('deliveryId', value),
                                             ref: deliveryRef,
                                             nextRef: hasteRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Delivery Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'hasteId',
                                          'Haste Id',
                                          accountList,
                                          {
                                             value: row.hasteId,
                                             onChange: (value) => handleInputChange('hasteId', value),
                                             ref: hasteRef,
                                             nextRef: masterRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Haste Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'masterId',
                                          'Master Id',
                                          accountList,
                                          {
                                             value: row.masterId,
                                             onChange: (value) => handleInputChange('masterId', value),
                                             ref: masterRef,
                                             nextRef: notesRef,
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Master Id',
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'notes',
                                          'Notes',
                                          {
                                             value: row.notes,
                                             onChange: (e) => handleInputChange('notes', e.target.value),
                                             ref: notesRef,
                                             nextRef: notes1Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   notes1Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'notes1',
                                          'Notes1',
                                          {
                                             value: row.notes1,
                                             onChange: (e) => handleInputChange('notes1', e.target.value),
                                             ref: notes1Ref,
                                             nextRef: notes2Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   notes2Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'notes2',
                                          'Notes2',
                                          {
                                             value: row.notes2,
                                             onChange: (e) => handleInputChange('notes2', e.target.value),
                                             ref: notes2Ref,
                                             nextRef: statusRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   statusRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'status',
                                          'Status',
                                          {
                                             isChecked: row.status,
                                             onChange: handleSwitchChange('status'),
                                             ref: statusRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   isBlacklistedRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isBlacklisted',
                                          'Blacklisted',
                                          {
                                             isChecked: row.isBlacklisted,
                                             onChange: handleSwitchChange('isBlacklisted'),
                                             ref: isBlacklistedRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (row.isBlacklisted) {
                                                      // If blacklisted is ON, focus on reason field
                                                      reasonRef.current?.focus();
                                                   } else if (row.glGroupId === 18 || row.glGroupId === 12) {
                                                      syncCodeRef.current?.focus();
                                                   } else {
                                                      sendWhatsAppRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>

                                    {row.isBlacklisted && (
                                       <GridItem className="seperator-width">
                                          {DynamicInput(
                                             'reason',
                                             'Reason For Blacklisting',
                                             {
                                                value: row.reason,
                                                onChange: (e) => handleInputChange('reason', e.target.value),
                                                ref: reasonRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      syncCodeRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             'text',
                                             false,
                                          )}
                                       </GridItem>
                                    )}
                                    {[18, 12].includes(row.glGroupId) && (
                                       <GridItem className="seperator-width">
                                          {DynamicInput(
                                             'syncCode',
                                             'Sync Code',
                                             {
                                                value: row.syncCode,
                                                onChange: (e) => handleInputChange('syncCode', e.target.value),
                                                ref: syncCodeRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      sendWhatsAppRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             'text',
                                             false,
                                          )}
                                       </GridItem>
                                    )}
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'sendWhatsApp',
                                          'Send WhatsApp',
                                          {
                                             isChecked: row.sendWhatsApp,
                                             onChange: handleSwitchChange('sendWhatsApp'),
                                             ref: sendWhatsAppRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   savecontinueRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 </>
                              )} */}
                           </Grid>
                        </GridItem>
                     </Grid>
                  </form>
               </ModalBody>
               <ModalFooter
                  className={`
    flex flex-wrap items-center justify-end gap-3 
    px-6 py-4 border-t
    ${isDark
                        ? 'border-gray-700 bg-gradient-to-b from-gray-900 to-gray-800'
                        : 'border-gray-200 bg-gradient-to-b from-gray-50 to-white'
                     }
  `}>
                  {/* Previous Button */}
                  {activeStep > 0 && (
                     <button
                        ref={previousRef}
                        onClick={handlePrevious}
                        variant="ghost"
                        className={`
        px-6 py-2.5 font-semibold rounded-xl transition-all duration-300 
        border-2 text-sm md:text-base
        transform hover:scale-105 active:scale-95
        shadow-sm hover:shadow-mdF
        focus:outline-none focus-visible:ring-4 
        ${isDark
                              ? `text-emerald-400 border-emerald-600/50 bg-transparent
             hover:bg-emerald-950/40 hover:border-emerald-500 hover:text-emerald-300
             focus-visible:ring-emerald-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900
             focus-visible:border-emerald-400 focus-visible:bg-emerald-950/40 
             focus-visible:shadow-[0_0_0_3px_rgba(16,185,129,0.4),0_0_20px_rgba(16,185,129,0.3)]
             focus-visible:scale-105`
                              : `text-emerald-600 border-emerald-400/60 bg-white
             hover:bg-emerald-50 hover:border-emerald-500 hover:text-emerald-700
             focus-visible:ring-emerald-400/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white
             focus-visible:border-emerald-500 focus-visible:bg-emerald-50 
             focus-visible:shadow-[0_0_0_3px_rgba(16,185,129,0.3),0_0_15px_rgba(16,185,129,0.2)]
             focus-visible:scale-105`
                           }
      `}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              if (activeStep !== steps.length - 1) {
                                 nextRef.current?.focus();
                              } else if (!isEditMode && saveandcontinue === true) {
                                 savecontinueRef.current?.focus();
                              } else {
                                 SaveFinishRef.current?.focus();
                              }
                           }
                        }}>
                        <div className="flex items-center gap-2">
                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                           </svg>
                           Previous
                        </div>
                     </button>
                  )}

                  {/* Next Button */}
                  {activeStep !== steps.length - 1 && (
                     <button
                        onClick={handleNext}
                        ref={nextRef}
                        className={`
        px-6 py-2.5 font-semibold rounded-xl transition-all duration-300 
        text-sm md:text-base border-2
        transform hover:scale-105 active:scale-95
        shadow-md hover:shadow-lg
        focus:outline-none focus-visible:ring-4
        ${isDark
                              ? `bg-blue-600 border-blue-500 text-white
             hover:bg-blue-500 hover:border-blue-400 hover:shadow-blue-500/50
             focus-visible:ring-blue-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900
             focus-visible:border-blue-300 focus-visible:bg-blue-500
             focus-visible:shadow-[0_0_0_3px_rgba(59,130,246,0.5),0_0_25px_rgba(59,130,246,0.4)]
             focus-visible:scale-105`
                              : `bg-blue-600 border-blue-500 text-white
             hover:bg-blue-500 hover:border-blue-400 hover:shadow-blue-500/50
             focus-visible:ring-blue-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white
             focus-visible:border-blue-500 focus-visible:bg-blue-500
             focus-visible:shadow-[0_0_0_3px_rgba(59,130,246,0.4),0_0_20px_rgba(59,130,246,0.3)]
             focus-visible:scale-105`
                           }
      `}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              if (!isEditMode && saveandcontinue === true) {
                                 savecontinueRef.current?.focus();
                              } else {
                                 SaveFinishRef.current?.focus();
                              }
                           } else if (e.key === 'ArrowLeft') {
                              e.preventDefault();
                              if (activeStep > 0) {
                                 previousRef.current?.focus();
                              }
                           }
                        }}>
                        <div className="flex items-center gap-2">
                           Next
                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                           </svg>
                        </div>
                     </button>
                  )}

                  {/* Save & Continue Button */}
                  {!isEditMode && saveandcontinue === true && (
                     <button
                        onClick={onsavecontinue}
                        ref={savecontinueRef}
                        disabled={isLoading}
                        className={`
        px-6 py-2.5 font-semibold rounded-xl transition-all duration-300 
        text-sm md:text-base border-2
        transform hover:scale-105 active:scale-95
        shadow-md hover:shadow-lg
        focus:outline-none focus-visible:ring-4
        ${isLoading ? 'opacity-70 cursor-not-allowed transform-none' : ''}
        ${isDark
                              ? `bg-emerald-600 border-emerald-500 text-white
             hover:bg-emerald-500 hover:border-emerald-400 hover:shadow-emerald-500/50
             focus-visible:ring-emerald-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900
             focus-visible:border-emerald-300 focus-visible:bg-emerald-500
             focus-visible:shadow-[0_0_0_3px_rgba(16,185,129,0.5),0_0_25px_rgba(16,185,129,0.4)]
             ${!isLoading ? 'focus-visible:scale-105' : ''}`
                              : `bg-emerald-600 border-emerald-500 text-white
             hover:bg-emerald-500 hover:border-emerald-400 hover:shadow-emerald-500/50
             focus-visible:ring-emerald-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white
             focus-visible:border-emerald-500 focus-visible:bg-emerald-500
             focus-visible:shadow-[0_0_0_3px_rgba(16,185,129,0.4),0_0_20px_rgba(16,185,129,0.3)]
             ${!isLoading ? 'focus-visible:scale-105' : ''}`
                           }
      `}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              SaveFinishRef.current?.focus();
                           } else if (e.key === 'ArrowLeft') {
                              e.preventDefault();
                              if (activeStep !== steps.length - 1) {
                                 nextRef.current?.focus();
                              } else if (activeStep > 0) {
                                 previousRef.current?.focus();
                              }
                           }
                        }}>
                        <div className="flex items-center gap-2">
                           {isLoading ? (
                              <>
                                 <svg
                                    className="w-4 h-4 animate-spin"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                       strokeWidth={2}
                                       d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                    />
                                 </svg>
                                 Saving...
                              </>
                           ) : (
                              <>
                                 <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                       strokeWidth={2.5}
                                       d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                                    />
                                 </svg>
                                 Save & Continue
                              </>
                           )}
                        </div>
                     </button>
                  )}

                  {/* Save & Finish Button */}
                  <button
                     onClick={onFormSubmit}
                     ref={SaveFinishRef}
                     disabled={isLoading}
                     className={`
      px-6 py-2.5 font-semibold rounded-xl transition-all duration-300 
      text-sm md:text-base border-2
      transform hover:scale-105 active:scale-95
      shadow-md hover:shadow-lg
      focus:outline-none focus-visible:ring-4
      ${isLoading ? 'opacity-70 cursor-not-allowed transform-none' : ''}
      ${isDark
                           ? `bg-emerald-600 border-emerald-500 text-white
           hover:bg-emerald-500 hover:border-emerald-400 hover:shadow-emerald-500/50
           focus-visible:ring-emerald-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900
           focus-visible:border-emerald-300 focus-visible:bg-emerald-500
           focus-visible:shadow-[0_0_0_3px_rgba(16,185,129,0.5),0_0_25px_rgba(16,185,129,0.4)]
           ${!isLoading ? 'focus-visible:scale-105' : ''}`
                           : `bg-emerald-600 border-emerald-500 text-white
           hover:bg-emerald-500 hover:border-emerald-400 hover:shadow-emerald-500/50
           focus-visible:ring-emerald-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white
           focus-visible:border-emerald-500 focus-visible:bg-emerald-500
           focus-visible:shadow-[0_0_0_3px_rgba(16,185,129,0.4),0_0_20px_rgba(16,185,129,0.3)]
           ${!isLoading ? 'focus-visible:scale-105' : ''}`
                        }
    `}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowRight') {
                           e.preventDefault();
                           cancelRef.current?.focus();
                        } else if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           if (!isEditMode && saveandcontinue === true) {
                              savecontinueRef.current?.focus();
                           } else if (activeStep !== steps.length - 1) {
                              nextRef.current?.focus();
                           } else if (activeStep > 0) {
                              previousRef.current?.focus();
                           }
                        }
                     }}>
                     <div className="flex items-center gap-2">
                        {isLoading ? (
                           <>
                              <svg
                                 className="w-4 h-4 animate-spin"
                                 fill="none"
                                 stroke="currentColor"
                                 viewBox="0 0 24 24">
                                 <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                 />
                              </svg>
                              Saving...
                           </>
                        ) : (
                           <>
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                 <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2.5}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                 />
                              </svg>
                              Save & Finish
                           </>
                        )}
                     </div>
                  </button>

                  {/* Cancel Button */}
                  <button
                     ref={cancelRef}
                     variant="ghost"
                     onClick={handleOnClose}
                     className={`
      px-6 py-2.5 font-semibold rounded-xl transition-all duration-300 
      text-sm md:text-base border-2
      transform hover:scale-105 active:scale-95
      shadow-sm hover:shadow-md
      focus:outline-none focus-visible:ring-4
      ${isDark
                           ? `text-gray-400 border-gray-600/50 bg-transparent
           hover:bg-gray-700/50 hover:border-gray-500 hover:text-gray-300
           focus-visible:ring-gray-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900
           focus-visible:border-gray-400 focus-visible:bg-gray-700/50 focus-visible:text-gray-300
           focus-visible:shadow-[0_0_0_3px_rgba(156,163,175,0.4),0_0_15px_rgba(156,163,175,0.3)]
           focus-visible:scale-105`
                           : `text-gray-600 border-gray-300/60 bg-white
           hover:bg-gray-100 hover:border-gray-400 hover:text-gray-700
           focus-visible:ring-gray-400/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white
           focus-visible:border-gray-400 focus-visible:bg-gray-100 
           focus-visible:shadow-[0_0_0_3px_rgba(156,163,175,0.3),0_0_12px_rgba(156,163,175,0.2)]
           focus-visible:scale-105`
                        }
    `}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           SaveFinishRef.current?.focus();
                        }
                     }}>
                     <div className="flex items-center gap-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                           />
                        </svg>
                        Cancel
                     </div>
                  </button>
               </ModalFooter>
               {/* <ModalFooter>
            <Button
              type="submit"
              onClick={handleSubmit}
              variant="darkBrand"
              color="white"
              fontSize="sm"
              fontWeight="500"
              borderRadius="full"
              px="24px"
              py="5px"
              _active={{ bg: '#06b' }}
              mr={5}
            >
              {isEditMode ? 'Update' : 'Save'}
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter> */}
            </ModalContent>
         </Modal>
      </>
   );
};

export default AddEditForm;
